import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import OfferV2PreviewApp from '../../OfferV2Preview/startup/OfferV2PreviewApp';
import LinkOfferModalApp from '../../LinkOfferModal/startup/LinkOfferModalApp';

import {SettlementMath} from "../../SettlementMath/SettlementMath";
import BudgetLineItems from "./BudgetLineItems";
import ForecastColumn from "./ForecastColumn";
import BudgetBonusManager from "./BudgetBonusManager";
import DepositManager from "./DepositManager";
import OfferManageContacts from "./OfferManageContacts";
import TagManagerApp from '../../TagManager/startup/TagManagerApp';
import EventDetails from '../../EventDetails/components/EventDetails';
import DealBracket from './DealBracket';
import useVenueAgeRestrictionOptions from '../../shared/hooks/useVenueAgeRestrictionOptions';
import OfferHeaderArtistPicker from './OfferHeaderArtistPicker';
import { needsLineupPerformer } from '../../../shared/offerLineupPerformer';
import { Alert, AlertTriangle, Badge } from '@opendate-app/setlist';

import {DebounceInput} from 'react-debounce-input';
import Select from 'react-select'
import Popup from "reactjs-popup";
import RichEditor from '../../RichEditor/components/RichEditor';
import Tippy from '@tippyjs/react';

import { ToastContainer, toast } from 'react-toastify';
import CurrencyInput from '../../CurrencyInput/components/CurrencyInput';

import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import { EditorState } from 'draft-js';
import { richTextToHtml, richTextContentFromHtml } from '../../shared/utils/richTextHtml';
import {GlobalCurrency} from '../../GlobalCurrency/GlobalCurrency';
import { splitShortfall } from '../utils/splitShortfall';
import { SplitShortfallCallout } from './SplitShortfallFlag';
import ToggleRevealTextarea from '../../../shared/ToggleRevealTextarea';
import popupContentStyle from '../../../shared/popupContentStyle';
import deleteModalContentStyle from '../../../shared/deleteModalContentStyle';
import darkSelectStyles from '../../../shared/darkSelectStyles';

var _ = require('lodash');
var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

TimeAgo.addDefaultLocale(en)
const timeAgo = new TimeAgo('en-US')

const parseFloatFromString = (value) => {
  if(typeof(value) === "number"){
    return value;
  }

  return parseFloat(value.split(",").join(""));
}

var _ = require('lodash');
var debouncedAutoSaveOffer;
var debouncedAutoSaveBudget;

const inlineMenuContentStyle = {...popupContentStyle("215px"), textAlign: "left"};

const templatetSaveMenuContentStyle = inlineMenuContentStyle;

const formatOptionLabel = ({ value, label }, {context}, deleteBudgetTemplate) => (
  <div className="d-flex justify-content-between budget-template-option">
    <p className="mb-0 text-overflow-ellipsis"
       title={label}>
      {label}
    </p>
    {context === "menu" ? (
      <a href="#"
         onClick={
           (e) => {
             e.preventDefault();
             e.stopPropagation();

             if(window.confirm("Are you sure? Delete \"" + label + "\"?")){
               deleteBudgetTemplate();
             }
           }
         }
         className="text-white">
        <i className="fas fa-trash"></i>
      </a>
    ) : null}
  </div>
);

const selectStyles = {
  container: (base, state) => ({
    ...base,
    opacity: state.isDisabled ? ".5" : "1",
    backgroundColor: "var(--od-c-fafafa, #F9F9F9)",
    zIndex: "999",
    width: "auto",
    marginBottom: "-10px"
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: 'var(--od-c-1982c4, #1982C4)'
    }
  },
  control: (styles, state) => {
    return {
      ...styles,
      backgroundColor: "var(--od-c-fafafa, #F9F9F9)",
      border: "none",
      boxShadow: 'none'
    };
  },
  valueContainer: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: "var(--od-c-fafafa, #F9F9F9)",
      fontWeight: "bold"
    };
  },
  singleValue: (styles, { data }) => {
    return {
      ...styles,
      fontWeight: "bold",
      color: "var(--od-c-1982c4, #1982C4)"
    };
  },
  indicatorSeparator: (styles, { data }) => {
    return {
      ...styles,
      display: "none"
    };
  },
  indicatorsContainer: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: "var(--od-c-fafafa, #F9F9F9)",
      color: "var(--od-c-1982c4, #1982C4)",
      fontWeight: "bold",
      fontSize: "16px",
      ':hover': {
        cursor: "pointer"
      }
    };
  },
  menu: (provided, state) => ({
    ...provided,
    width: "230px",
    backgroundColor: "var(--od-c-ffffff, #fff)"
  }),
  menuPortal: base => ({ ...base, zIndex: 10000 }),
  option: (provided, state) => ({
    ...provided,
    color: state.isFocused ? 'white' : 'var(--od-c-333333, #333333)',
    background: state.isFocused ? '#1982C4' : 'var(--od-c-ffffff, white)',
    fontWeight: state.isFocused ? 'bold' : 'normal',
    padding: "0px",
    "&:hover": {
      color: "white",
      background: "var(--od-c-1982c4, #1982C4)",
      fontWeight: "bold"
    }
  }),
  dropdownIndicator: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: "var(--od-c-fafafa, #F9F9F9)",
      color: "var(--od-c-1982c4, #1982C4)",
      fontWeight: "bold",
      "&:hover": {
        color: "var(--od-c-1982c4, #1982C4)"
      }
    };
  }
};

const artistActTypeSelectStyles = {
  container: (base, state) => ({
    ...base,
    width: "120px"
  }),
  control: (base, state) => ({
    ...base,
    color: "var(--od-c-1982c4, #2c86c5)",
    textAlign: "right",
    border: "none",
    backgroundColor: "transparent",
    boxShadow: "none",
    borderColor: "var(--sl-bg-active)",
    "&:hover": {
      borderColor: "var(--sl-bg-active)",
    },
  }),
  dropdownIndicator: base => ({
    ...base,
    color: "var(--od-c-1982c4, #2c86c5)",
    "&:hover": {
      color: "var(--od-c-1982c4, #2c86c5)",
    },
  }),
  singleValue: (base, state) => ({
    ...base,
    color: "var(--od-c-1982c4, #2c86c5)"
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "var(--od-c-ffffff, #fff)"
  }),
  option: (base, state) => ({
    ...base,
    color: state.isSelected ? "white" : "var(--od-c-1982c4, #2c86c5)",
    backgroundColor: state.isSelected
      ? "var(--od-c-1982c4, #2c86c5)"
      : "transparent",
    "&:hover": {
      backgroundColor: !state.isSelected ? "var(--sl-bg-active)" : "var(--od-c-1982c4, #2c86c5)",
      color: !state.isSelected ? "var(--od-c-1982c4, #2c86c5)" : "white",
    },
    "&:focus": {
      backgroundColor: "transparent",
    },
  })
}


const modalContentStyle = popupContentStyle("800px");

const linkOfferModalContentStyle = popupContentStyle("700px");

// https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
const numberStringWithCommas = (x) => {
  return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const formatCalculatedNumber = (calculated, options={}) => {
  var absValue  = Math.abs(calculated);
  var formatted = numberStringWithCommas(Number(absValue).toFixed(2));

  if(options.prefix){
    formatted = options.prefix + formatted;
  }

  if(calculated < 0){
    formatted = "(" + formatted + ")";
  }

  return formatted;
}

const formatFacilitiesMaintenanceFee = (calculated, forecast = false) => {
  if(Object.keys(calculated).length === 0){
    return 0.00;
  }

  var item = calculated
    .beforeAdjustedDeductionsSection
    .items
    .find((item) => item.name === "Facilities Maintenance Fee");

  return forecast ? item.calculatedForecastTotal : item.calculatedTotal;
}

const formatCharitableDeduction = (calculated, forecast = false) => {
  if(Object.keys(calculated).length === 0){
    return 0.00;
  }

  var item = calculated
    .beforeAdjustedDeductionsSection
    .items
    .find((item) => item.name === "Charitable Deduction");

  return forecast ? item.calculatedForecastTotal : item.calculatedTotal;
}

const canSubmitBudgetTemplate = (budgetTemplate) => {
  return (
    budgetTemplate
      && budgetTemplate.name
      && budgetTemplate.name.length > 0
  );
}

const updatedBudgetRemovingBudgetLineItem = (budget, budgetLineItem) => {
  var ticketLineItems = budget.ticket_line_items.filter((item) =>
    item.uuid !== budgetLineItem.uuid
  );

  var additionLineItems = budget.addition_line_items.filter((item) =>
    item.uuid !== budgetLineItem.uuid
  );

  var incomeLineItems = budget.income_line_items.filter((item) =>
    item.uuid !== budgetLineItem.uuid
  );

  var beforeAdjustedDeductionsLineItems = budget.before_adjusted_deductions_line_items.filter((item) =>
    item.uuid !== budgetLineItem.uuid
  );

  var expenseLineItems = budget.expense_line_items.filter((item) =>
    item.uuid !== budgetLineItem.uuid
  );

  return Object.assign({}, budget, {
    ticket_line_items: ticketLineItems,
    addition_line_items: additionLineItems,
    income_line_items: incomeLineItems,
    before_adjusted_deductions_line_items: beforeAdjustedDeductionsLineItems,
    expense_line_items: expenseLineItems
  });
}

const tableWidth = (showCurrencyConversion, showForecast) => {
  var baseWidth = 835;
  var currencyWidth = showCurrencyConversion ? 130 : 0;
  var forecastWidth = showForecast ? 365 : 60;

  var width = baseWidth + currencyWidth + forecastWidth;

  return `${width}px`;
}

const OfferEditUI = ({
  csrfToken,
  team,
  currentUser,
  offer,
  offerChanged,
  updateOfferAdditionalTermsFromHTML,
  autoSaveOffer,
  budget,
  createTicketBudgetLineItem,
  createAdditionBudgetLineItem,
  createIncomeBudgetLineItem,
  createBeforeAdjustedDeductionsBudgetLineItem,
  createExpensesBudgetLineItem,
  deleteBudgetLineItem,
  autoSaveBudgetLineItem,
  updateOffer,
  updateBudget,
  autoSaveBudget,
  acceptOffer,
  declineOffer,
  deleteOffer,
  calculated,
  updateCalculated,
  modalUIState,
  updateModalUIState,
  isSaving,
  isCreatingTemplate,
  isCreatingTemplateChanged,
  submitBudgetTemplate,
  budgetTemplates,
  useBudgetTemplateWithBudget,
  budgetTemplate,
  budgetTemplateNameChanged,
  budgetTemplateChanged,
  offerToLink,
  offerToLinkChanged,
  deleteBudgetTemplate,
  createBudgetBonus,
  deleteBudgetBonus,
  autoSaveBudgetBonus,
  getActiveTags,
  getAvailableTags,
  offerContacts,
  offerContactsChanged,
  dealBrackets,
  dealBracketsChanged,
  dealBracketChanged
}) => {
  let venueCapacity;
  if(offer.calendar_event && offer.calendar_event.venue_capacity){
    venueCapacity = offer.calendar_event.venue_capacity;
  } else if(offer.venue && offer.venue.capacity){
    venueCapacity = offer.venue.capacity;
  }

  const { options: ageRestrictionOptions } = useVenueAgeRestrictionOptions(team?.id, offer.venue_ownership?.id);

  const dealBracketCapacity = dealBrackets.reduce((sum, dealBracket) => {
    return sum + (parseInt(dealBracket.quantity) || 0);
  }, 0);

  const showDealBracketsAlert = (
    venueCapacity &&
      !budget.from_dollar_one &&
      venueCapacity > dealBracketCapacity
  );

  const hasSecondaryCurrencySymbol = (
    typeof(team.secondary_currency_symbol) === "string"
      && team.secondary_currency_symbol.length > 0
  );

  const currencySymbol = (
    hasSecondaryCurrencySymbol ?
      team.secondary_currency_symbol : "USD"
  )

  const globalCurrency = new GlobalCurrency(
    team.currency_conversion_rate, currencySymbol
  );

  const showSecondaryDollarAmountField = (
    hasSecondaryCurrencySymbol
      && offer.display_currency_conversion_for_offer
  );

  const showCurrencyConversion = (
    hasSecondaryCurrencySymbol
      && offer.display_currency_conversion_for_offer
      && !team.convert_artist_earnings_only
  );

  const convertedOrZero = (calculated, options={}) => {
    if(Object.keys(calculated).length === 0){
      return globalCurrency.formatted(0.00);
    }

    var amount = options.amount ?
      options.amount : _.get(calculated, options.dotPath, 0.00);

    return globalCurrency.formatted(amount);
  }

  useEffect(() => {
    updateOfferAdditionalTermsFromHTML(offer.additional_terms || "");

    var updateOnInit = {};

    if(budget.upside_percentage){
      updateOnInit = Object.assign({}, updateOnInit, {
        upside_percentage: parseFloatFromString(budget.upside_percentage).toFixed(2)
      });
    }

    if(budget.dollar_amount_with_two_decimals){
      updateOnInit = Object.assign({}, updateOnInit, {
        dollar_amount: budget.dollar_amount_with_two_decimals
      });
    }

    var budgetBonuses = [...budget.budget_bonuses].map((bb) => {
      var attrs = {};

      if(bb.dollar_amount){
        var dollarAmountTwoDecimals = parseFloatFromString(bb.dollar_amount).toFixed(2);
        attrs = {...attrs, dollar_amount: dollarAmountTwoDecimals};
      }

      if(bb.upside_percentage){
        var upsidePercentageTwoDecimals = parseFloatFromString(bb.upside_percentage).toFixed(2);
        attrs = {...attrs, upside_percentage: upsidePercentageTwoDecimals};
      }

      return Object.assign({}, bb, attrs);
    });
    updateOnInit = Object.assign({}, updateOnInit, {
      budget_bonuses: budgetBonuses
    });

    var updated = Object.assign({}, budget, updateOnInit);
    updateBudget(updated);

    debouncedAutoSaveOffer = _.debounce((csrfToken, team, offer, additionalOfferTerms) => {
      autoSaveOffer(csrfToken, team, offer, additionalOfferTerms);
    }, 2000);

    debouncedAutoSaveBudget = _.debounce((csrfToken, team, budget) => {
      autoSaveBudget(csrfToken, team, budget);
    }, 2000);

    var calculator = new SettlementMath(budget);
    var calculated = calculator.calculate();
    updateCalculated(calculated);
  }, [])

  useEffect(() => {
    setDollarAmount(budget.dollar_amount || "");
    setUpsidePercentage(budget.upside_percentage || "");
  }, [budget])

  // Triggers a re-calculation of the budget when the deal brackets change
  useEffect(() => {
    updateBudget({...budget, deal_brackets: dealBrackets});
  }, [dealBrackets])

  const [dollarAmount, setDollarAmount] = useState(budget.dollar_amount || "");
  const [upsidePercentage, setUpsidePercentage] = useState(budget.upside_percentage || "");
  const [additionalOfferTerms, setAdditionalOfferTerms] = useState(null);
  const [secondaryDollarAmount, setSecondaryDollarAmount] = useState("");

  const forecastColgroup = (
    <colgroup>
      <col style={{minWidth: "110px", maxWidth: "110px"}} />
      <col style={{minWidth: "95px", maxWidth: "95px"}} />
      {showCurrencyConversion ? (
        <col style={{minWidth: "130px", maxWidth: "130px"}} />
      ) : null}
      <col style={{minWidth: "130px", maxWidth: "130px"}} />
    </colgroup>
  );

  useEffect(() => {
    setAdditionalOfferTerms(
      EditorState.createWithContent(richTextContentFromHtml(offer.additional_terms || ""))
    );
  }, [offer.additional_terms])

  useEffect(() => {
    var amount = budget.dollar_amount;
    var converted = "";

    if(amount && amount.length > 0){
      var dollarAmount = parseFloatFromString(amount);
      converted = globalCurrency.convert(dollarAmount).toFixed(2);
    }

    setSecondaryDollarAmount(converted);
  }, [budget.dollar_amount])

  const shortfall = Object.keys(calculated).length > 0 ? splitShortfall(calculated, null, budget) : null;

  const createDealBracket = () => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    
    return axios.post(`/teams/${team.id}/deal_brackets`, {
      deal_bracket: {
        budget_id: budget.id,
        dollar_or_percentage_operator: "AND",
        dollar_amount: 0,
        upside_percentage: 0
      }
    })
    .then(({ data }) => {
      const updatedDealBrackets = [...dealBrackets, data];
      dealBracketsChanged(updatedDealBrackets);
    })
    .catch((error) => {
      toast.error('Failed to create offer detail');
    });
  };

  const missingLineupPerformer = needsLineupPerformer(offer, offer.calendar_event?.performers);

  return (
    <div>
      <ToastContainer icon={false} />
      <div className="row">
        <div className="col-12 mb-1">
          <div className="page-title">
            {offer.event_name}
            {offer.state === "draft" ? (
              <span className="badge badge-secondary ml-3 p-2"
                    style={{"fontSize": "10px"}}>
                Draft
              </span>
            ) : offer.state === "sent" ? (
              <span className="badge badge-primary ml-3 p-2"
                    style={{"fontSize": "10px"}}>
                Sent
              </span>
            ) : offer.state === "accepted" ? (
              <span className="badge badge-success ml-3 p-2"
                    style={{"fontSize": "10px"}}>
                Accepted
              </span>
            ) : offer.state === "declined" ? (
              <span className="badge badge-danger ml-3 p-2"
                    style={{"fontSize": "10px"}}>
                Declined
              </span>
            ) : null}
            {missingLineupPerformer ? (
              <span className="ml-3 align-middle">
                <Badge type="pill-color" color="warning" size="sm" icon={AlertTriangle}>No artist attached</Badge>
              </span>
            ) : null}
            {offer.calendar_event && offer.calendar_event.id ? (
              <a href={`/teams/${team.id}/confirms/${offer.calendar_event.id}`}
                  className='ml-3'
                  style={{"fontSize": "14px", "fontWeight": "600"}}>
                Go to Event Details <i className="fas fa-arrow-right"></i>
              </a>
            ) : null}
          </div>
        </div>
      </div>
      <div className='row'>
        <div className="col">
          {offer.calendar_event ? (
            <EventDetails
              csrfToken={csrfToken}
              team={team}
              confirm={offer.calendar_event}
              venueOwnerships={team.venue_ownerships}
              rooms={team.rooms}
              currentUser={currentUser}
              onConfirmSaved={(updatedConfirm) => {
                if (offerChanged) {
                  offerChanged({
                    ...offer,
                    calendar_event: updatedConfirm
                  });
                }
              }}
            />
          ) : (
            <p className="text-muted mb-3 align-self-center">
              {offer.human_metadata}
            </p>
          )}
        </div>
        <div className="col-xs-auto d-flex align-items-end"
             style={{"paddingRight": "15px"}}>
          <Popup
              trigger={
                <a href="#"
                   className="btn btn-external shadow-2 btn-sm mb-3"
                   style={{"borderRadius": "8px"}}>
                  <i className="fas fa-cog"></i>
                </a>
              }
              onOpen={
                (e) => {
                  e.preventDefault();
                }
              }
              arrow={false}
              offsetY={10}
              position="bottom right"
              contentStyle={inlineMenuContentStyle}
              closeOnDocumentClick
            >
            {close => (
              <div>
                <div className="row">
                  <div className="col">
                    <ul className="list-group offer-inline-menu highlight-primary">
                      <li className="list-group-item">
                        <a href={`/teams/${team.id}/offers/${offer.id}`}
                           className="text-dark">
                          <i className="text-muted fas fa-eye fa-fw mx-2"></i>
                          <span style={{"fontWeight": 'normal'}}>
                            Preview
                          </span>
                        </a>
                      </li>
                      <li className="list-group-item">
                        <a href={"/teams/" + team.id + "/offers/" + offer.id + "/preview.pdf"}
                           target={"_blank"}
                           className="text-dark">
                          <i className="text-muted fas fa-arrow-to-bottom fa-fw mx-2"></i>
                          <span style={{"fontWeight": 'normal'}}>
                            Download
                          </span>
                        </a>
                      </li>
                      {["draft", "sent"].includes(offer.state) ? (
                        <li className="list-group-item">
                          <a href="#"
                             className="text-dark"
                             onClick={
                               (e) => {
                                 e.preventDefault();
                                 acceptOffer(team, offer.id, csrfToken);
                                 close();
                               }
                             }>
                            <i className="text-muted far fa-check-circle fa-fw mx-2"></i>
                            <span style={{"fontWeight": 'normal'}}>
                              Mark accepted
                            </span>
                          </a>
                        </li>
                      ) : null}
                      {["draft", "sent"].includes(offer.state) ? (
                        <li className="list-group-item">
                          <a href="#"
                             className="text-dark"
                             onClick={
                               (e) => {
                                 e.preventDefault();
                                 declineOffer(team, offer.id, csrfToken);
                                 close();
                               }
                             }>
                            <i className="text-muted far fa-times-circle fa-fw mx-2"></i>
                            <span style={{"fontWeight": 'normal'}}>
                              Mark declined
                            </span>
                          </a>
                        </li>
                      ) : null}
                      {!offer.calendar_event ? (
                        <li className="list-group-item">
                          <a href="#"
                             className="text-dark"
                             onClick={
                               (e) => {
                                 e.preventDefault();
                                 close();
                                 offerToLinkChanged(offer);
                               }
                             }>
                            <i className="text-muted far fa-link fa-fw mx-2"></i>
                            <span style={{"fontWeight": 'normal'}}>
                              Link with event
                            </span>
                          </a>
                        </li>
                      ) : null}
                      <li className="list-group-item delete-offer-li border-0">
                        <Popup
                            trigger={
                              <a href="#"
                                 onClick={
                                   (e) => {
                                     e.preventDefault();
                                   }
                                 }
                                 className="text-danger">
                                <i className="far fa-trash fa-fw mx-2"></i>
                                <span style={{"fontWeight": 'normal'}}>
                                  Delete
                                </span>
                              </a>
                            }
                            modal
                            contentStyle={deleteModalContentStyle}
                            closeOnDocumentClick
                          >
                          {closeDeletePopup => (
                            <div>
                              <div className="row">
                                <div className="col">
                                  <div className="row">
                                    <div className="col">
                                      <h5 style={{"marginBottom": "16px"}}>
                                        <div className="strong">Delete offer?</div>
                                      </h5>
                                    </div>
                                    <div className="col-xs-auto">
                                      <a href="#"
                                         className="text-dark"
                                         style={{"paddingRight": "15px"}}
                                         onClick={(e) => {e.preventDefault(); closeDeletePopup();}} >
                                        <i className="fa fa-times"></i>
                                      </a>
                                    </div>
                                  </div>
                                  <p>You're about to delete this offer.</p>
                                  <p>This cannot be undone.</p>
                                  <p>Are you sure?</p>
                                  <div className="text-right">
                                    <a href="#"
                                       onClick={
                                         (e) => {
                                           e.preventDefault();
                                           closeDeletePopup();
                                         }
                                       }>
                                      Cancel
                                    </a>
                                    <a href="#"
                                       className="btn btn-danger ml-3"
                                       onClick={
                                         (e) => {
                                           e.preventDefault();
                                           closeDeletePopup();
                                           close();
                                           deleteOffer(team, offer.id, csrfToken);
                                         }
                                       }>
                                      Yes, delete offer
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </Popup>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </Popup>
        </div>
      </div>
      <div className='row'>
        <div className="col-12 col-md-6 d-flex align-items-center justify-content-start small">
          <div className='row'>
            {budgetTemplates.length > 0 ? (
              <div className="col-xs-auto"
                   style={{
                     "paddingLeft": "15px"
                   }}>
                <Select styles={selectStyles}
                        placeholder={"Select a template"}
                        menuPortalTarget={document.body}
                        components={{ ClearIndicator:() => null }}
                        options={budgetTemplates.sort((a, b) => a.label.localeCompare(b.label))}
                        value={budgetTemplates.find((t) => t.value === budget.template_id)}
                        formatOptionLabel={
                          (data, meta) => {
                            return formatOptionLabel(data, meta, () => {
                              deleteBudgetTemplate(csrfToken, team, data.value);
                            });
                          }
                        }
                        onChange={
                          (selected) => {
                            isCreatingTemplateChanged(false);
                            useBudgetTemplateWithBudget(csrfToken, team, budget, offer, selected.value);
                          }
                        } />
              </div>
            ) : null}
            <div className="col d-flex align-items-end justify-content-start small">
              {isCreatingTemplate ? (
                <div>
                  <form onSubmit={
                    (e) => {
                      e.preventDefault();

                      if(!canSubmitBudgetTemplate(budgetTemplate)){
                        return false;
                      }

                      submitBudgetTemplate(csrfToken, team, offer, budget, budgetTemplate, additionalOfferTerms);
                    }
                  }>
                    <div className="input-group">
                      <input type="text"
                             className="form-control"
                             value={budgetTemplate.name || ""}
                             onChange={
                               (e) => {
                                 budgetTemplateNameChanged(e.target.value);
                               }
                             }
                             style={{
                               "border": "1px solid var(--od-c-e9eaeb, #e6e6e6)",
                               "borderRight": "none",
                               "borderTopLeftRadius": "4px",
                               "borderBottomLeftRadius": "4px"
                             }}
                             placeholder="Enter template name..." />
                      <div className="input-group-append">
                        <button className="btn text-primary"
                                style={{
                                  "background": "var(--od-c-ffffff, white)",
                                  "border": "1px solid var(--od-c-e9eaeb, #e6e6e6)",
                                  "borderLeft": "none",
                                  "borderTopRightRadius": "4px",
                                  "borderBottomRightRadius": "4px"
                                }}
                                disabled={!canSubmitBudgetTemplate(budgetTemplate)}
                                type="submit">
                          <strong>Save</strong>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                budgetTemplates.map((t) => t.value).includes(budget.template_id) ? (
                  <Popup
                      trigger={
                        <a href="#"
                           onClick={
                             (e) => {
                               e.preventDefault();
                             }
                           }>
                          <strong>
                            Save to current template
                            <i className="fas fa-caret-down ml-3"></i>
                          </strong>
                        </a>
                      }
                      onOpen={
                        (e) => {
                          e.preventDefault();
                        }
                      }
                      arrow={false}
                      offsetY={10}
                      position="bottom center"
                      contentStyle={templatetSaveMenuContentStyle}
                      closeOnDocumentClick
                    >
                    {close => (
                      <div>
                        <div className="row">
                          <div className="col">
                            <ul className="list-group offer-inline-menu highlight-primary"
                                style={{"fontSize": "14px"}}>
                              <li className="list-group-item pl-3 pb-2 pt-3">
                                <a href="#"
                                   className="text-dark"
                                   onClick={
                                     (e) => {
                                       e.preventDefault();

                                       var option = budgetTemplates.find((t) => t.value === budget.template_id);
                                       var budgetTemplate = Object.assign({}, {
                                         id: option.value,
                                         name: option.label
                                       });

                                       budgetTemplateChanged(budgetTemplate);
                                       isCreatingTemplateChanged(true);
                                       close();
                                     }
                                   }>
                                  <span style={{"fontWeight": 'normal'}}>
                                    Save to current template
                                  </span>
                                </a>
                              </li>
                              <li className="list-group-item pl-3 pt-2 pb-3">
                                <a href="#"
                                   className="text-dark"
                                   onClick={
                                     (e) => {
                                       e.preventDefault();
                                       isCreatingTemplateChanged(true);
                                       close();
                                     }
                                   }>
                                  <span style={{"fontWeight": 'normal'}}>
                                    Save as new template
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </Popup>
                ) : (
                  <a href="#"
                     onClick={
                       (e) => {
                         e.preventDefault();
                         isCreatingTemplateChanged(true);
                       }
                     }>
                    <strong>
                      Save as...
                      <i className="far fa-copy ml-3"></i>
                    </strong>
                  </a>
                )
              )}
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
          {isSaving ? (
            <a href="#"
               className="text-muted">
              <i className="far fa-sync mr-2 fa-rotate-90"></i>
              Automatically saving changes
            </a>
          ) : (
            <Tippy content={
                     <div style={{
                            "fontSize": "10px"
                          }}>
                       <p className="mb-0">Every change you make is automatically saved in Opendate.</p>
                       <p className="mb-0">Last edit was {timeAgo.format(new Date(offer.updated_at))}.</p>
                     </div>
                   }
                   placement={'top-start'}
                   maxWidth={390}
                   animation={'shift-away'}
                   theme='material'>
              <a href="#"
                 className="text-muted">
                <i className="far fa-check-circle mr-2"></i>
                Changes automatically saved
              </a>
            </Tippy>
          )}
          <a href="#"
             className={"ml-3 btn btn-primary"}
             onClick={
               (e) => {
                 e.preventDefault();
                 updateModalUIState("SEND");
               }
             }>
            <strong>
              Send Offer
            </strong>
          </a>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12">
          <div className="card no-border shadow-2">
            <div className="card-body"
                 style={{"padding": "35px 25px"}}>
              <div className="form-row">
                <div className="col-12 col-lg-6 col-xl-8">
                  <div className='row mb-2'>
                    <div className='col-12 d-flex align-items-center'>
                      <p className='mb-0' style={{"fontSize": "16px"}}>
                        <strong>Artist</strong>
                      </p>
                    </div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-12" style={{ maxWidth: "510px" }}>
                      {offer.performer_id || (offer.primary_performer && offer.primary_performer._destroy !== true) ? (
                        <div
                          className="p-3 rounded d-flex align-items-center justify-content-between"
                          style={{backgroundColor: "var(--sl-bg-active)"}}
                        >
                          <div className="d-flex align-items-center">
                            <div className="col-xs-auto">
                              <img src={offer.calendar_event && offer.performer ? (
                                offer.performer.artistable?.image_thumb_url_for_json
                              ) : (
                                offer.primary_performer.artistable?.image_thumb_url_for_json
                              )}
                                   className="img-fluid rounded-circle mr-3 less-opacity-when-disabled"
                                   style={{"height": "40px", "width": "40px"}} />
                            </div>
                            <p className="mb-0" style={{fontSize: "14px"}}>
                              <strong>
                                {offer.calendar_event && offer.performer ? (
                                  offer.performer.artistable?.name
                                ) : (
                                  offer.primary_performer.artistable?.name
                                )}
                              </strong>
                            </p>
                          </div>
                          <div className="d-flex align-items-center">
                            <Select
                              className="mr-2"
                              styles={artistActTypeSelectStyles}
                              placeholder="Act type"
                              isSearchable={false}
                              components={{IndicatorSeparator: () => null}}
                              value={offer.calendar_event && offer.performer?.act_type ? {
                                label: offer.performer.humanized_act_type,
                                value: offer.performer.act_type
                              } : offer.primary_performer?.act_type ? {
                                label: offer.primary_performer?.humanized_act_type,
                                value: offer.primary_performer?.act_type
                              } : null}
                              options={[
                                {value: "headline", label: "Headliner"},
                                {value: "support", label: "Support"},
                              ]}
                              onChange={option => {
                                var updated;

                                if(offer.calendar_event?.performers?.some(p => p.id === offer.performer?.id)) {
                                  updated = {
                                    ...offer,
                                    savePerformer: true,
                                    performer: {
                                      ...offer.performer,
                                      act_type: option.value,
                                      humanized_act_type: option.label
                                    }
                                  };
                                } else {
                                  updated = {
                                    ...offer,
                                    savePerformer: true,
                                    primary_performer: {
                                      ...offer.primary_performer,
                                      act_type: option.value,
                                      humanized_act_type: option.label
                                    }
                                  };
                                }

                                updateOffer(updated);
                                autoSaveOffer(csrfToken, team, updated, additionalOfferTerms);
                              }}
                            />
                            <a
                              href="#"
                              style={{color: "var(--od-c-1982c4, #2c86c5)"}}
                              onClick={e => {
                                e.preventDefault();

                                var updated;

                                if(offer.calendar_event && offer.performer) {
                                  updated = {
                                    ...offer,
                                    savePerformer: true,
                                    performer_id: null,
                                    performer: {
                                      id: null,
                                      _destroy: true
                                    },
                                    primary_performer: {
                                      id: offer.primary_performer.id,
                                      _destroy: true
                                    }
                                  };
                                } else {
                                  updated = {
                                    ...offer,
                                    savePerformer: true,
                                    primary_performer: {
                                      id: offer.primary_performer.id,
                                      _destroy: true
                                    }
                                  };
                                }

                                updateOffer(updated);
                                autoSaveOffer(csrfToken, team, updated, additionalOfferTerms);
                              }}
                            >
                              <i className="fas fa-times"></i>
                            </a>
                          </div>
                        </div>
                      ) : (
                        <div className="form-row" style={{marginBottom: "14px"}}>
                          <div className="col-12 col-xs-auto">
                            {missingLineupPerformer ? (
                              <div className="mb-3">
                                <Alert
                                  color="warning"
                                  size="full-width"
                                  title="No artist attached."
                                  description="Pick the performer from this event so the deal links to settlement and the agent's copy."
                                />
                              </div>
                            ) : null}
                            <OfferHeaderArtistPicker
                              offer={offer}
                              teamId={team.id}
                              onUpdate={(updated) => {
                                updateOffer(updated);
                                autoSaveOffer(csrfToken, team, updated, additionalOfferTerms);
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='row mb-2'>
                    <div className='col-12 d-flex align-items-center justify-content-start'>
                      <p className='mb-0 mr-3' style={{"fontSize": "16px"}}>
                        <strong>Offer Details</strong>
                      </p>
                      {team.allow_deal_bracket_offers ? (
                        <div className="custom-control custom-checkbox custom-checkbox-table">
                          <input type="checkbox"
                                  className="custom-control-input"
                                  id="budget-from-dollar-one"
                                  checked={budget.from_dollar_one || false}
                                  onChange={e => {
                                    var updated = Object.assign({}, budget, {from_dollar_one: e.target.checked});

                                    updateBudget(updated);
                                    autoSaveBudget(csrfToken, team, updated);
                                  }} />
                          <label className="custom-control-label"
                                  style={{"fontSize": "14px"}}
                                  htmlFor="budget-from-dollar-one">
                            From Dollar One
                          </label>
                        </div>
                      ) : null}
                    </div>
                    {showDealBracketsAlert ? (
                      <div className="col-12">
                        <div className="alert alert-warning d-flex align-items-start"
                              style={{"marginTop": "10px", "marginBottom": "0px"}}>
                          <i className="fas fa-exclamation-triangle mr-3 mt-1"
                              style={{"color": "#856404", "fontSize": "20px"}}></i>
                          <div>
                            <p className="mb-0"
                                style={{"fontSize": "14px"}}>
                              <strong>Offer details don't cover full venue capacity</strong>
                            </p>
                            <p className="mb-0"
                                style={{"fontSize": "14px"}}>
                              Your offer details cover <strong>{dealBracketCapacity.toLocaleString()}</strong> tickets, but this venue has a capacity of <strong>{venueCapacity.toLocaleString()}</strong> tickets. Consider adding more offer details to define terms for all {venueCapacity.toLocaleString()} seats in case of a sellout.
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {budget.from_dollar_one ? (
                  <div className='row'>
                    <div className={"col-12"}>
                      <div className="form-row"
                          style={{"marginBottom": "14px"}}>
                        <div className="col-12 col-sm-auto"
                          style={showSecondaryDollarAmountField ? {"width": "350px"} : {"width": "200px"}}>
                          <div className="form-group mb-0">
                            <label className="text-muted"
                                  style={{"whiteSpace": "nowrap"}}
                                  htmlFor="offer-dollar-amount">
                              Offer Amount
                            </label>
                            {showSecondaryDollarAmountField ? (
                              <div className='d-flex'>
                                <div className="input-group inline-white"
                                    style={{
                                      "border": "1px solid var(--od-c-e9eaeb, #e6e6e6)",
                                      "borderRadius": "4px",
                                      "borderTopRightRadius": "0px",
                                      "borderBottomRightRadius": "0px"
                                    }}>
                                  <div className="input-group-prepend">
                                    <span className="input-group-text px-1"
                                          style={{"color": "var(--od-c-a4a7ae, #9b9b9b)"}}
                                          id="offer-dollar-amount-dollar-sign">
                                      <strong>{team.base_currency_symbol}</strong>
                                    </span>
                                  </div>
                                  <CurrencyInput className="form-control px-0"
                                                maskOptions={{
                                                  prefix: "",
                                                  integerLimit: null
                                                }}
                                                placeholder={"0"}
                                                value={budget.dollar_amount || ""}
                                                onChange={
                                                  (e) => {
                                                    var updated = Object.assign({}, budget, {dollar_amount: e.target.value});

                                                    updateBudget(updated);
                                                    debouncedAutoSaveBudget(csrfToken, team, updated);
                                                  }
                                                }
                                                id="offer-dollar-amount"
                                                aria-describedby="offer-dollar-amount-dollar-sign" />
                                </div>
                                <div className="input-group inline-white"
                                    style={{
                                      "borderTop": "1px solid var(--od-c-e9eaeb, #e6e6e6)",
                                      "borderRight": "1px solid var(--od-c-e9eaeb, #e6e6e6)",
                                      "borderBottom": "1px solid var(--od-c-e9eaeb, #e6e6e6)",
                                      "borderRadius": "4px",
                                      "borderTopLeftRadius": "0px",
                                      "borderBottomLeftRadius": "0px"
                                    }}>
                                  <div className="input-group-prepend">
                                    <span className="input-group-text px-1"
                                          style={{"color": "var(--od-c-a4a7ae, #9b9b9b)"}}
                                          id="offer-secondary-dollar-amount-dollar-sign">
                                      <strong>{team.secondary_currency_symbol}</strong>
                                    </span>
                                  </div>
                                  <CurrencyInput className="form-control px-0"
                                                maskOptions={{
                                                  prefix: "",
                                                  integerLimit: null
                                                }}
                                                placeholder={"0"}
                                                value={secondaryDollarAmount || ""}
                                                onChange={
                                                  (e) => {
                                                    var amount = e.target.value;
                                                    var converted = "";

                                                    if(amount && amount.length > 0){
                                                      var dollarAmount = parseFloatFromString(amount);
                                                      converted = globalCurrency.revert(dollarAmount).toFixed(2);
                                                    }

                                                    var updated = {
                                                      ...budget,
                                                      dollar_amount: converted
                                                    }

                                                    updateBudget(updated);
                                                    setSecondaryDollarAmount(amount);
                                                    debouncedAutoSaveBudget(csrfToken, team, updated);
                                                  }
                                                }
                                                id="offer-secondary-dollar-amount"
                                                aria-describedby="offer-secondary-dollar-amount-dollar-sign" />
                                </div>
                              </div>
                            ) : (
                              <div className="input-group inline-white"
                                  style={{
                                    "border": "1px solid var(--od-c-e9eaeb, #e6e6e6)",
                                    "borderRadius": "4px"
                                  }}>
                                <div className="input-group-prepend">
                                  <span className="input-group-text px-2"
                                        id="offer-dollar-amount-dollar-sign">
                                    <i className="far fa-dollar-sign text-muted"></i>
                                  </span>
                                </div>
                                <CurrencyInput
                                  id="offer-dollar-amount"
                                  aria-describedby="offer-dollar-amount-dollar-sign"
                                  className="form-control"
                                  maskOptions={{ prefix: "", integerLimit: null }}
                                  placeholder={"Enter amount"}
                                  value={dollarAmount || 0.00}
                                  onChange={e => {
                                    setDollarAmount(current => {
                                      if(current !== e.target.value){
                                        var updated = {
                                          ...budget,
                                          dollar_amount: e.target.value
                                        };

                                        updateBudget(updated);
                                        debouncedAutoSaveBudget(csrfToken, team, updated);

                                        return updated.dollar_amount;
                                      }
                                    })
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-sm-auto">
                          <div className="btn-group btn-group-sm"
                              style={{
                                "marginTop": "29px",
                                "border": "1px solid var(--od-c-1982c4, #1982C4)",
                                "borderRadius": "9px",
                                "background": "var(--od-c-1982c4, #1982C4)"
                              }}
                              role="group">
                            <button type="button"
                                    style={{"borderTopLeftRadius": "8px", "borderBottomLeftRadius": "8px"}}
                                    onClick={
                                      (e) => {
                                        e.preventDefault();
                                        var updated = Object.assign({}, budget, {dollar_or_percentage_operator: "AND"});

                                        updateBudget(updated);
                                        debouncedAutoSaveBudget(csrfToken, team, updated);
                                      }
                                    }
                                    className={"btn strong " + (budget.dollar_or_percentage_operator === 'AND' ? "btn-primary" : "btn-external-inverse")}>
                              <i className='fa-solid fa-plus mx-1'></i>
                            </button>
                            <button type="button"
                                    style={{"borderTopRightRadius": "8px", "borderBottomRightRadius": "8px"}}
                                    onClick={
                                      (e) => {
                                        e.preventDefault();
                                        var updated = Object.assign({}, budget, {dollar_or_percentage_operator: "OR"});

                                        updateBudget(updated);
                                        debouncedAutoSaveBudget(csrfToken, team, updated);
                                      }
                                    }
                                    className={"btn strong " + (budget.dollar_or_percentage_operator === 'OR' ? "btn-primary" : "btn-external-inverse")}>
                              VS
                            </button>
                          </div>
                        </div>
                        <div className="col-12 col-sm-auto"
                              style={{"maxWidth": "200px"}}>
                          <div className="form-group mb-0">
                            <label className="text-muted"
                                  style={{"whiteSpace": "nowrap"}}
                                  htmlFor="offer-upside-percentage">
                              Percentage of ticket sales
                            </label>
                            <div className="input-group inline-white"
                                style={{
                                  "border": "1px solid var(--od-c-e9eaeb, #e6e6e6)",
                                  "borderRadius": "4px"
                                }}>
                              <CurrencyInput
                                id="offer-upside-percentage"
                                aria-describedby="offer-upside-percentage-percentage"
                                className="form-control"
                                maskOptions={{ prefix: "", integerLimit: null }}
                                placeholder={"0.00"}
                                value={upsidePercentage || 0.00}
                                onChange={e => {
                                  setUpsidePercentage(current => {
                                    if(current !== e.target.value){
                                      var updated = {
                                        ...budget,
                                        upside_percentage: e.target.value
                                      }

                                      updateBudget(updated);
                                      debouncedAutoSaveBudget(csrfToken, team, updated);

                                      return updated.upside_percentage;
                                    }
                                  })
                                }}
                              />
                              <div className="input-group-append">
                                <span className="input-group-text px-2"
                                      id="offer-upside-percentage-percentage">
                                  <i className="far fa-percentage text-muted"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {budget.guarantee_notes != null && (
                        <div style={{"marginBottom": "14px"}}>
                          <ToggleRevealTextarea
                            value={budget.guarantee_notes}
                            onChange={(val) => {
                              var updated = Object.assign({}, budget, { guarantee_notes: val });
                              updateBudget(updated);
                              debouncedAutoSaveBudget(csrfToken, team, updated);
                            }}
                            onRemove={() => {
                              var updated = Object.assign({}, budget, { guarantee_notes: null });
                              updateBudget(updated);
                              debouncedAutoSaveBudget(csrfToken, team, updated);
                            }}
                            onAdd={() => {
                              var updated = Object.assign({}, budget, { guarantee_notes: '' });
                              updateBudget(updated);
                            }}
                            label="Guarantee Notes"
                            placeholder="e.g., all-in, multi-night terms"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  ) : (
                    <>
                      <DragDropContext onDragEnd={
                        (result) => {
                          if (!result.destination) {
                            return false;
                          }

                          var itemIndex = result.source.index;
                          var moveIndex = result.destination.index;

                          var dealBracketsCopy = [...dealBrackets];
                          var [removed] = dealBracketsCopy.splice(itemIndex, 1);
                          dealBracketsCopy.splice(moveIndex, 0, removed);

                          var updated = dealBracketsCopy.map((bracket, index) =>
                            Object.assign({}, bracket, {position: (index + 1)})
                          );

                          dealBracketsChanged(updated);

                          var updatedBracket = Object.assign({}, updated[moveIndex], {
                            position: (moveIndex + 1)
                          });

                          axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
                          axios.patch(`/teams/${team.id}/deal_brackets/${updatedBracket.id}`, {
                            deal_bracket: {
                              position: updatedBracket.position
                            }
                          }).catch(error => {
                            toast.error('Failed to save deal bracket position');
                          });
                        }
                      }>
                        <Droppable droppableId="deal-brackets-droppable">
                          {(provided, snapshot) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {dealBrackets.sort((a, b) => (a.position || 0) - (b.position || 0)).map((dealBracket, index) => (
                                <Draggable key={"" + dealBracket.id} draggableId={"" + dealBracket.id} index={index}>
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                    >
                                      <DealBracket csrfToken={csrfToken}
                                                  key={dealBracket.id}
                                                  team={team}
                                                  offer={offer}
                                                  dealBracket={dealBracket}
                                                  dealBracketChanged={dealBracketChanged}
                                                  dealBrackets={dealBrackets}
                                                  dealBracketsChanged={dealBracketsChanged}
                                                  showSecondaryDollarAmountField={showSecondaryDollarAmountField}
                                                  isFirstBracket={index === 0}
                                                  index={index}
                                                  provided={provided}
                                                  snapshot={snapshot} />
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                      <div className="row">
                        <div className="col-12 mb-3">
                          <a href="#"
                            onClick={
                              (e) => {
                                e.preventDefault();
                                createDealBracket();
                              }
                            }
                            className="text-primary">
                            <strong><i className="fal fa-plus"></i> Add Offer Detail</strong>
                          </a>
                        </div>
                      </div>
                    </>
                  )}
                  <BudgetBonusManager csrfToken={csrfToken}
                                      team={team}
                                      currentUser={currentUser}
                                      updateBudget={updateBudget}
                                      debouncedAutoSaveBudget={debouncedAutoSaveBudget}
                                      createBudgetBonus={createBudgetBonus}
                                      deleteBudgetBonus={deleteBudgetBonus}
                                      autoSaveBudgetBonus={autoSaveBudgetBonus}
                                      budget={budget}
                                      dealBrackets={dealBrackets}
                                      hideAddLink />
                  <div className="d-flex" style={{ gap: '16px', marginTop: budget.budget_bonuses.length === 0 ? '-5px' : '20px', marginBottom: '27px' }}>
                    {budget.guarantee_notes == null && (
                      <a href="#"
                         onClick={(e) => {
                           e.preventDefault();
                           var updated = Object.assign({}, budget, { guarantee_notes: '' });
                           updateBudget(updated);
                         }}
                         className="text-primary">
                        <strong><i className="fal fa-plus"></i> Add Guarantee Notes</strong>
                      </a>
                    )}
                    <a href="#"
                       onClick={(e) => {
                         e.preventDefault();
                         createBudgetBonus(csrfToken, team, budget);
                       }}
                       className="text-primary">
                      <strong><i className="fal fa-plus"></i> Add Bonus</strong>
                    </a>
                  </div>
                  <div className='row'>
                    <div
                      className='col-12 mb-2 d-flex align-items-center'
                      style={{"height": "42px"}}
                    >
                      <div className="custom-control custom-checkbox custom-checkbox-table">
                        <input
                          id="offer-promoter-profit"
                          type="checkbox"
                          className="custom-control-input"
                          checked={budget.promoter_profit}
                          onChange={e => {
                            var updated = Object.assign({}, budget, {
                              promoter_profit: e.target.checked
                            });

                            updateBudget(updated);
                            autoSaveBudget(csrfToken, team, updated)
                          }}
                        />
                        <label
                          htmlFor="offer-promoter-profit"
                          className="custom-control-label"
                          style={{"fontSize": "14px"}}
                        >
                          <strong>
                            Promoter Profit
                          </strong>
                        </label>
                      </div>
                      {budget.promoter_profit ? (
                        <div
                          className="ml-3 input-group inline-white"
                          style={{
                            width: "120px",
                            border: "1px solid var(--od-c-e9eaeb, #e6e6e6)",
                            borderRadius: "4px"
                          }}
                        >
                          <CurrencyInput
                            id="offer-promoter-profit-percentage"
                            aria-describedby="offer-promoter-profit-percentage"
                            className="form-control pr-1"
                            style={{
                              textAlign: "right"
                            }}
                            maskOptions={{
                              prefix: "",
                              integerLimit: null,
                              allowDecimal: true,
                              decimalLimit: 5,
                            }}
                            placeholder={"0.0"}
                            value={budget.promoter_profit_percentage || 0.00}
                            onChange={e => {
                              var updated = Object.assign({}, budget, {
                                promoter_profit_percentage: e.target.value
                              });

                              updateBudget(updated);
                              debouncedAutoSaveBudget(csrfToken, team, updated);
                            }}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text px-2">
                              <i className="far fa-percentage text-muted"></i>
                            </span>
                          </div>
                        </div>
                      ) : (null)}
                    </div>
                  </div>
                  {offer.calendar_event ? null : (
                    <div className='row'>
                      <div className='col-12 mb-2 d-flex align-items-center'>
                        <label
                          htmlFor="offer-age-restriction"
                          className="mb-0 mr-3"
                          style={{"fontSize": "14px", "minWidth": "120px"}}
                        >
                          <strong>Age Restriction</strong>
                        </label>
                        <div style={{"width": "260px"}}>
                          <Select
                            inputId="offer-age-restriction"
                            styles={darkSelectStyles}
                            options={ageRestrictionOptions}
                            isClearable={true}
                            placeholder="Select age restriction"
                            value={ageRestrictionOptions.find(opt => opt.value === offer.age_restriction) || null}
                            onChange={(selected) => {
                              const updated = Object.assign({}, offer, {
                                age_restriction: selected ? selected.value : null
                              });

                              updateOffer(updated);
                              autoSaveOffer(csrfToken, team, updated, additionalOfferTerms);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-12 col-lg-6 col-xl-4">
                  {hasSecondaryCurrencySymbol ? (
                    <div className='col-12 mb-2 pr-0 d-flex align-items-center justify-content-end'>
                      <div className="custom-control custom-checkbox custom-checkbox-table">
                        <input type="checkbox"
                                className="custom-control-input"
                                checked={offer.display_currency_conversion_for_offer}
                                onChange={
                                  (e) => {
                                    var updated = Object.assign({}, offer, {
                                      display_currency_conversion_for_offer: e.target.checked
                                    });

                                    updateOffer(updated);
                                    autoSaveOffer(csrfToken, team, updated, additionalOfferTerms);
                                  }
                                }
                                id="offer-display-currency-conversion-for-offer" />
                        <label className="custom-control-label"
                                style={{"fontSize": "14px"}}
                                htmlFor="offer-display-currency-conversion-for-offer">
                          {`Display currency conversion (1 ${team.base_currency_symbol} / ${team.currency_conversion_rate} ${team.secondary_currency_symbol})`}
                        </label>
                      </div>
                    </div>
                  ) : null}
                  <div className="card border-0 my-3 ml-auto px-4 col-12 col-lg-10"
                       style={{"background": "var(--sl-bg-active)"}}>
                    <div className="card-body px-0 py-3">
                      <p className='mb-2 text-center text-lg-left' style={{"fontSize": "16px"}}>
                        <strong>
                          Tickets to Breakeven
                          {Object.keys(calculated).length > 0 && calculated.artistEarnings.ticketsToBreakeven ? (
                            <Tippy
                              content={
                                <div style={{"fontSize": "10px", "padding": "5px 8px"}}>
                                  <p className="mb-0">
                                    Tickets to breakeven is calculated by dividing total expenses (guarantee + show expenses) by the weighted average ticket price (total revenue / total tickets sold).
                                  </p>
                                  <table
                                    className='table table-dark table-sm table-borderless'
                                    style={{"marginTop": "20px", "background": "#333333"}}>
                                    <thead>
                                      <tr>
                                        <th className='text-left py-0'>
                                          Calculation
                                        </th>
                                        <th className='text-right py-0'>As Offered</th>
                                        {calculated.artistEarningsForecast.ticketsToBreakeven ? (
                                          <th className='text-right py-0'>Forecasted</th>
                                        ) : null}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td className='text-left py-0'>Total Tickets</td>
                                        <td className='text-right py-0'>
                                          {calculated.ticketsToBreakeven.totalTickets.toLocaleString()}
                                        </td>
                                        {calculated.artistEarningsForecast.ticketsToBreakeven ? (
                                          <td className='text-right py-0'>
                                            {calculated.ticketsToBreakevenForecast.totalTickets.toLocaleString()}
                                          </td>
                                        ) : null}
                                      </tr>
                                      <tr>
                                        <td className='text-left py-0'>Total Revenue</td>
                                        <td className='text-right py-0'>
                                          {formatter.format(calculated.ticketsToBreakeven.totalRevenue)}
                                        </td>
                                        {calculated.artistEarningsForecast.ticketsToBreakeven ? (
                                          <td className='text-right py-0'>
                                            {formatter.format(calculated.ticketsToBreakevenForecast.totalRevenue)}
                                          </td>
                                        ) : null}
                                      </tr>
                                      <tr>
                                        <td className='text-left py-0'>Total Expenses</td>
                                        <td className='text-right py-0'>
                                          {formatter.format(calculated.ticketsToBreakeven.totalExpenses)}
                                        </td>
                                        {calculated.artistEarningsForecast.ticketsToBreakeven ? (
                                          <td className='text-right py-0'>
                                            {formatter.format(calculated.ticketsToBreakevenForecast.totalExpenses)}
                                          </td>
                                        ) : null}
                                      </tr>
                                      <tr>
                                        <td className='text-left py-0' colSpan={calculated.artistEarningsForecast.ticketsToBreakeven ? 3 : 2}>
                                          <hr className='my-1' style={{"borderTop": "1px solid #555"}} />
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className='text-left py-0'>Avg Ticket Price</td>
                                        <td className='text-right py-0'>
                                          {formatter.format(calculated.ticketsToBreakeven.weightedAverageTicketPrice)}
                                        </td>
                                        {calculated.artistEarningsForecast.ticketsToBreakeven ? (
                                          <td className='text-right py-0'>
                                            {formatter.format(calculated.ticketsToBreakevenForecast.weightedAverageTicketPrice)}
                                          </td>
                                        ) : null}
                                      </tr>
                                      <tr>
                                        <td className='text-left py-0'></td>
                                        <td className='text-right py-0' style={{"fontSize": "9px", "fontStyle": "italic", "paddingTop": "2px"}}>
                                          ({formatter.format(calculated.ticketsToBreakeven.totalRevenue)} / {calculated.ticketsToBreakeven.totalTickets.toLocaleString()})
                                        </td>
                                        {calculated.artistEarningsForecast.ticketsToBreakeven ? (
                                          <td className='text-right py-0' style={{"fontSize": "9px", "fontStyle": "italic", "paddingTop": "2px"}}>
                                            ({formatter.format(calculated.ticketsToBreakevenForecast.totalRevenue)} / {calculated.ticketsToBreakevenForecast.totalTickets.toLocaleString()})
                                          </td>
                                        ) : null}
                                      </tr>
                                      <tr>
                                        <td className='text-left py-0' colSpan={calculated.artistEarningsForecast.ticketsToBreakeven ? 3 : 2}>
                                          <hr className='my-1' style={{"borderTop": "1px solid #555"}} />
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className='text-left py-0'><strong>Breakeven</strong></td>
                                        <td className='text-right py-0'>
                                          <strong>{calculated.artistEarnings.ticketsToBreakeven.toLocaleString()}</strong>
                                        </td>
                                        {calculated.artistEarningsForecast.ticketsToBreakeven ? (
                                          <td className='text-right py-0'>
                                            <strong>{calculated.artistEarningsForecast.ticketsToBreakeven.toLocaleString()}</strong>
                                          </td>
                                        ) : null}
                                      </tr>
                                      <tr>
                                        <td className='text-left py-0'></td>
                                        <td className='text-right py-0' style={{"fontSize": "9px", "fontStyle": "italic", "paddingTop": "2px"}}>
                                          ({formatter.format(calculated.ticketsToBreakeven.totalExpenses)} / {formatter.format(calculated.ticketsToBreakeven.weightedAverageTicketPrice)})
                                        </td>
                                        {calculated.artistEarningsForecast.ticketsToBreakeven ? (
                                          <td className='text-right py-0' style={{"fontSize": "9px", "fontStyle": "italic", "paddingTop": "2px"}}>
                                            ({formatter.format(calculated.ticketsToBreakevenForecast.totalExpenses)} / {formatter.format(calculated.ticketsToBreakevenForecast.weightedAverageTicketPrice)})
                                          </td>
                                        ) : null}
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              }
                              placement={'top'}
                              maxWidth={390}
                              animation={'shift-away'}
                              theme='material'>
                              <a href="#" className="text-muted">
                                <i className="fas fa-info-circle ml-2"></i>
                              </a>
                            </Tippy>
                          ) : null}
                        </strong>
                      </p>
                      <h3 className="mb-3 text-center text-lg-left">
                        {Object.keys(calculated).length > 0 && calculated.artistEarnings.ticketsToBreakeven ? (
                          calculated.artistEarnings.ticketsToBreakeven.toLocaleString()
                        ) : (
                          0
                        )}
                        <span
                          className="ml-2"
                          style={{"fontSize": "16px"}}
                        >
                          as offered
                        </span>
                      </h3>
                      {Object.keys(calculated).length > 0 && calculated.artistEarningsForecast.ticketsToBreakeven ? (
                        <h4 className="mb-0 text-center text-lg-left">
                          {calculated.artistEarningsForecast.ticketsToBreakeven.toLocaleString()}
                          <span
                            className="text-muted ml-2"
                            style={{"fontSize": "16px"}}
                          >
                            as forecasted
                          </span>
                        </h4>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              {currentUser.can_read_tagged_items ? (
                <div className="ml-auto col-12 col-lg-6 col-xl-5 px-0">
                  <TagManagerApp
                    csrfToken={csrfToken}
                    team={team}
                    currentUser={currentUser}
                    scope="Offer"
                    title="Tags for Offer"
                    taggable={offer}
                    activeTagsAlignment="right"
                  />
                </div>
              ) : null}
              <hr className="mb-4" style={{"borderTop": "2px solid var(--od-c-e9eaeb, #e6e6e6)"}} />
              <div style={{
                "maxWidth": "100%",
                "overflowX": "auto",
                "overflowY": "hidden"
              }}>
                <table
                  className="table mt-3 mb-4 budget-line-item-table"
                  style={{
                    minWidth: tableWidth(showCurrencyConversion, offer.display_forecast),
                    tableLayout: "fixed"
                  }}>
                  <tbody className="border-0">
                    <tr>
                      <td style={{padding: "0px", width: "auto", minWidth: "180px"}}>&nbsp;</td>
                      <td style={{padding: "0px", width: "75px"}}>&nbsp;</td>
                      <td style={{padding: "0px", width: "75px"}}>&nbsp;</td>
                      <td style={{padding: "0px", width: "75px"}}>&nbsp;</td>
                      <td style={{padding: "0px", width: "100px"}}>&nbsp;</td>
                      <td style={{padding: "0px", width: "110px"}}>&nbsp;</td>
                      {showCurrencyConversion ? (
                        <td style={{padding: "0px", width: "130px"}}>&nbsp;</td>
                      ) : null}
                      <td style={{padding: "0px", width: "130px"}}>&nbsp;</td>
                      {offer.display_forecast ? (
                        <td style={{padding: "0px", width: showCurrencyConversion ? "495px" : "365px"}}>&nbsp;</td>
                      ) : (
                        <td style={{padding: "0px", width: "60px"}}>&nbsp;</td>
                      )}
                      <td style={{padding: "0px", width: "10px"}}>&nbsp;</td>
                    </tr>
                  </tbody>
                  <tbody className="border-0">
                    <tr>
                      <td
                        colSpan={showCurrencyConversion ? 8 : 7}
                        className="pb-0">
                        <h3 style={{"fontSize": "20px"}}
                            className="mb-1">
                          <strong>Budget</strong>
                        </h3>
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        colgroup={forecastColgroup}
                        top={true}
                        showCurrencyConversion={showCurrencyConversion}
                      >
                        <div className={offer.display_forecast ? "text-right pr-3" : "text-center"}>
                          <Tippy content={offer.display_forecast ? "Hide Forecast" : "Show Forecast"}
                                 placement="top"
                                 maxWidth={120}
                                 animation="shift-away"
                                 theme="material">
                            <a href="#"
                               onClick={e => {
                                e.preventDefault();

                                var updated = Object.assign({}, offer, {
                                  display_forecast: !offer.display_forecast
                                });

                                updateOffer(updated);
                                autoSaveOffer(csrfToken, team, updated, additionalOfferTerms);
                               }}
                              >
                              <i className="fas fa-columns-3"></i>
                            </a>
                          </Tippy>
                        </div>
                      </ForecastColumn>
                      <td className="px-0">
                        &nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={showCurrencyConversion ? 8 : 7}>
                        <h4 style={{"fontSize": "16px"}}
                            className="mb-0">
                          <strong>INCOME</strong>
                        </h4>
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        showCurrencyConversion={showCurrencyConversion}
                      >
                        <div className="text-center strong">
                          Forecast
                        </div>
                      </ForecastColumn>
                      <td className="px-0">
                        &nbsp;
                      </td>
                    </tr>
                  </tbody>
                  <BudgetLineItems
                    team={team}
                    csrfToken={csrfToken}
                    currentUser={currentUser}
                    budget={budget}
                    calculatedBudget={calculated}
                    budgetLineItems={budget.ticket_line_items}
                    header={"Tickets"}
                    updateBudget={updateBudget}
                    formatCalculatedNumber={formatCalculatedNumber}
                    total={Object.keys(calculated).length > 0 ? (
                      calculated.ticketsSection.total
                    ) : (
                      0.00
                    )}
                    getCalculatedRow={budgetLineItem => {
                      var items = Object.keys(calculated).length > 0 ?
                       calculated.ticketsSection.items : [];

                      return items.find((item) => {
                        return item.uuid === budgetLineItem.uuid;
                      });
                    }}
                    namePrefix={"Ticket #"}
                    onAddRow={e => {
                      createTicketBudgetLineItem(csrfToken, team, budget, (budget.ticket_line_items.length + 1));
                    }}
                    onDeleteRow={budgetLineItem => {
                      var updated = updatedBudgetRemovingBudgetLineItem(budget, budgetLineItem);

                      updateBudget(updated);
                      deleteBudgetLineItem(csrfToken, team, budgetLineItem);
                    }}
                    autoSaveBudgetLineItem={autoSaveBudgetLineItem}
                    showCurrencyConversion={showCurrencyConversion}
                    globalCurrency={globalCurrency}
                    showForecast={offer.display_forecast}
                    forecastColgroup={forecastColgroup}
                  />
                  <tbody>
                    <tr>
                      <td
                        colSpan={showCurrencyConversion ? 8 : 7}
                        className="p-0 border-0">
                        &nbsp;
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        showCurrencyConversion={showCurrencyConversion}
                      />
                      <td className="px-0">&nbsp;</td>
                    </tr>
                  </tbody>
                  <BudgetLineItems
                    team={team}
                    csrfToken={csrfToken}
                    currentUser={currentUser}
                    budget={budget}
                    calculatedBudget={calculated}
                    budgetLineItems={budget.addition_line_items}
                    header={"Additions"}
                    updateBudget={updateBudget}
                    formatCalculatedNumber={formatCalculatedNumber}
                    total={Object.keys(calculated).length > 0 ? (
                      calculated.additionsSection.total
                    ) : (
                      0.00
                    )}
                    getCalculatedRow={budgetLineItem => {
                      var items = Object.keys(calculated).length > 0 ?
                       calculated.additionsSection.items : [];

                      return items.find((item) => {
                        return item.uuid === budgetLineItem.uuid;
                      });
                    }}
                    namePrefix={"Addition #"}
                    onAddRow={e => {
                      createAdditionBudgetLineItem(csrfToken, team, budget, (budget.addition_line_items.length + 1));
                    }}
                    onDeleteRow={budgetLineItem => {
                      var updated = updatedBudgetRemovingBudgetLineItem(budget, budgetLineItem);

                      updateBudget(updated);
                      deleteBudgetLineItem(csrfToken, team, budgetLineItem);
                    }}
                    autoSaveBudgetLineItem={autoSaveBudgetLineItem}
                    showCurrencyConversion={showCurrencyConversion}
                    globalCurrency={globalCurrency}
                    showForecast={offer.display_forecast}
                    forecastColgroup={forecastColgroup}
                  />
                  <tbody>
                    <tr>
                      <td
                        colSpan={showCurrencyConversion ? 8 : 7}
                        className="p-0 border-0">
                        &nbsp;
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        showCurrencyConversion={showCurrencyConversion}
                      />
                      <td className="px-0">&nbsp;</td>
                    </tr>
                  </tbody>
                  <BudgetLineItems
                    team={team}
                    csrfToken={csrfToken}
                    currentUser={currentUser}
                    budget={budget}
                    calculatedBudget={calculated}
                    budgetLineItems={budget.income_line_items}
                    header={"Other Income"}
                    updateBudget={updateBudget}
                    formatCalculatedNumber={formatCalculatedNumber}
                    total={Object.keys(calculated).length > 0 ? (
                      calculated.revenueSection.total
                    ) : (
                      0.00
                    )}
                    getCalculatedRow={budgetLineItem => {
                      var items = Object.keys(calculated).length > 0 ?
                       calculated.revenueSection.items : [];

                      return items.find((item) => {
                        return item.uuid === budgetLineItem.uuid;
                      });
                    }}
                    namePrefix={"Income #"}
                    onAddRow={e => {
                      createIncomeBudgetLineItem(csrfToken, team, budget, (budget.income_line_items.length + 1));
                    }}
                    onDeleteRow={budgetLineItem => {
                      var updated = updatedBudgetRemovingBudgetLineItem(budget, budgetLineItem);

                      updateBudget(updated);
                      deleteBudgetLineItem(csrfToken, team, budgetLineItem);
                    }}
                    autoSaveBudgetLineItem={autoSaveBudgetLineItem}
                    showCurrencyConversion={showCurrencyConversion}
                    globalCurrency={globalCurrency}
                    showForecast={offer.display_forecast}
                    forecastColgroup={forecastColgroup}
                  />
                  <tbody>
                    <tr>
                      <td colSpan={showCurrencyConversion ? 8 : 7}>
                        &nbsp;
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        showCurrencyConversion={showCurrencyConversion}
                      />
                      <td className="px-0">&nbsp;</td>
                    </tr>
                    <tr>
                      <td colSpan="6" className="border-0 text-right">
                        <strong>
                          Gross Potential
                        </strong>
                      </td>
                      {showCurrencyConversion  ? (
                        <td className="border-0 text-right pl-0">
                          <strong>
                            {convertedOrZero(calculated, {
                              amount: Object.keys(calculated).length > 0 ?
                                calculated.ticketsSection.total + calculated.revenueSection.total : 0
                            })}
                          </strong>
                        </td>
                      ) : null}
                      <td className="border-0 text-right">
                        <strong>
                          {Object.keys(calculated).length > 0 ? (
                            formatCalculatedNumber(calculated.ticketsSection.total + calculated.revenueSection.total, {prefix: "$"})
                          ) : (
                            formatCalculatedNumber(0.00, {prefix: "$"})
                          )}
                        </strong>
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        colgroup={forecastColgroup}
                        showCurrencyConversion={showCurrencyConversion}
                        values={{
                          convertedTotal: (
                            <strong>
                              {convertedOrZero(calculated, {
                                amount: Object.keys(calculated).length > 0 ?
                                  calculated.ticketsSection.externalForecastTotal + calculated.revenueSection.externalForecastTotal : 0
                              })}
                            </strong>
                          ),
                          total: (
                            <strong>
                              {Object.keys(calculated).length > 0 ? (
                                formatCalculatedNumber(calculated.ticketsSection.externalForecastTotal + calculated.revenueSection.externalForecastTotal, {prefix: "$"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </strong>
                          )
                        }}
                      />
                      <td className="px-0">&nbsp;</td>
                    </tr>
                  </tbody>
                  <tbody className="border-0">
                    <tr>
                      <td colSpan={showCurrencyConversion ? 8 : 7}>
                        <h4 style={{"fontSize": "16px"}}
                          className="mb-0">
                          <strong>BEFORE ADJUSTED DEDUCTIONS</strong>
                        </h4>
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        showCurrencyConversion={showCurrencyConversion}
                      />
                      <td className="px-0">&nbsp;</td>
                    </tr>
                  </tbody>
                  <BudgetLineItems
                    team={team}
                    csrfToken={csrfToken}
                    currentUser={currentUser}
                    budget={budget}
                    calculatedBudget={calculated}
                    budgetLineItems={budget.before_adjusted_deductions_line_items}
                    header={"Before Adjusted Deductions"}
                    updateBudget={updateBudget}
                    formatCalculatedNumber={formatCalculatedNumber}
                    total={Object.keys(calculated).length > 0 ? (
                      calculated.beforeAdjustedDeductionsSection.total
                    ) : (
                      0.00
                    )}
                    getCalculatedRow={budgetLineItem => {
                      var items = Object.keys(calculated).length > 0
                        ? calculated.beforeAdjustedDeductionsSection.items
                        : [];

                      return items.find((item) => {
                        return item.uuid === budgetLineItem.uuid;
                      });
                    }}
                    namePrefix={"Before Adjusted Deduction #"}
                    onAddRow={e => {
                      createBeforeAdjustedDeductionsBudgetLineItem(csrfToken, team, budget, (budget.before_adjusted_deductions_line_items.length + 1));
                    }}
                    onDeleteRow={budgetLineItem => {
                      var updated = updatedBudgetRemovingBudgetLineItem(budget, budgetLineItem);

                      updateBudget(updated);
                      deleteBudgetLineItem(csrfToken, team, budgetLineItem);
                    }}
                    autoSaveBudgetLineItem={autoSaveBudgetLineItem}
                    showCurrencyConversion={showCurrencyConversion}
                    globalCurrency={globalCurrency}
                    showForecast={offer.display_forecast}
                    forecastColgroup={forecastColgroup}
                  />
                  <tbody>
                    <tr>
                      <td
                        colSpan={showCurrencyConversion ? 8 : 7}
                        className="p-0 border-0">
                        &nbsp;
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        showCurrencyConversion={showCurrencyConversion}
                      />
                      <td className="px-0">&nbsp;</td>
                    </tr>
                    <tr>
                      <td colSpan="6" className="border-0 text-right">
                        <strong>
                          Adjusted Gross Potential
                        </strong>
                      </td>
                      {showCurrencyConversion  ? (
                        <td className="border-0 text-right pl-0">
                          <strong>
                            {Object.keys(calculated).length > 0 ? (
                              convertedOrZero(calculated, {dotPath: "showSummary.netBoxOfficeReceipts"})
                            ) : (
                              formatCalculatedNumber(0.00, {prefix: "$"})
                            )}
                          </strong>
                        </td>
                      ) : null}
                      <td className="border-0 text-right">
                        <strong>
                          {Object.keys(calculated).length > 0 ? (
                            formatCalculatedNumber(calculated.showSummary.netBoxOfficeReceipts, {prefix: "$"})
                          ) : (
                            formatCalculatedNumber(0.00, {prefix: "$"})
                          )}
                        </strong>
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        colgroup={forecastColgroup}
                        showCurrencyConversion={showCurrencyConversion}
                        values={{
                          convertedTotal: (
                            <strong>
                              {Object.keys(calculated).length > 0 ? (
                                convertedOrZero(calculated, {dotPath: "showSummary.netBoxOfficeReceiptsForecast"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </strong>
                          ),
                          total: (
                            <strong>
                              {Object.keys(calculated).length > 0 ? (
                                formatCalculatedNumber(calculated.showSummary.netBoxOfficeReceiptsForecast, {prefix: "$"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </strong>
                          )
                        }}
                      />
                      <td className="px-0">&nbsp;</td>
                    </tr>
                  </tbody>
                  <tbody className="border-0">
                    <tr>
                      <td colSpan={showCurrencyConversion ? 8 : 7}>
                        <h4 style={{"fontSize": "16px"}}
                          className="mb-0">
                          <strong>EXPENSES</strong>
                        </h4>
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        showCurrencyConversion={showCurrencyConversion}
                      />
                      <td className="px-0">&nbsp;</td>
                    </tr>
                  </tbody>
                  <BudgetLineItems
                    team={team}
                    csrfToken={csrfToken}
                    currentUser={currentUser}
                    budget={budget}
                    calculatedBudget={calculated}
                    budgetLineItems={budget.expense_line_items}
                    header={"Expenses"}
                    updateBudget={updateBudget}
                    formatCalculatedNumber={formatCalculatedNumber}
                    total={Object.keys(calculated).length > 0 ? (
                      calculated.expensesSection.total + calculated.finalExpensesSection.total
                    ) : (
                      0.00
                    )}
                    getCalculatedRow={budgetLineItem => {
                      var items = Object.keys(calculated).length > 0
                        ? calculated.expensesSection.items.concat(calculated.finalExpensesSection.items)
                        : [];

                      return items.find((item) => {
                        return item.uuid === budgetLineItem.uuid;
                      });
                    }}
                    namePrefix={"Expense #"}
                    onAddRow={e => {
                      createExpensesBudgetLineItem(csrfToken, team, budget, (budget.expense_line_items.length + 1));
                    }}
                    onDeleteRow={budgetLineItem => {
                      var updated = updatedBudgetRemovingBudgetLineItem(budget, budgetLineItem);

                      updateBudget(updated);
                      deleteBudgetLineItem(csrfToken, team, budgetLineItem);
                    }}
                    autoSaveBudgetLineItem={autoSaveBudgetLineItem}
                    showCurrencyConversion={showCurrencyConversion}
                    globalCurrency={globalCurrency}
                    showForecast={offer.display_forecast}
                    forecastColgroup={forecastColgroup}
                  />
                  <tbody>
                    <tr>
                      <td
                        colSpan={showCurrencyConversion ? 8 : 7}
                        className="p-0">
                        &nbsp;
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        showCurrencyConversion={showCurrencyConversion}
                      />
                      <td className="px-0">&nbsp;</td>
                    </tr>
                    <tr>
                      <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                        Gross Potential
                      </td>
                      {showCurrencyConversion  ? (
                        <td className="pl-0 pt-0 pb-0 border-0 text-right">
                          {convertedOrZero(calculated, {
                            amount: Object.keys(calculated).length > 0 ?
                              calculated.ticketsSection.total + calculated.revenueSection.total : 0
                          })}
                        </td>
                      ) : null}
                      <td className="pl-0 pt-0 pb-0 border-0 text-right">
                        {Object.keys(calculated).length > 0 ? (
                          formatCalculatedNumber(calculated.ticketsSection.total + calculated.revenueSection.total, {prefix: "$"})
                        ) : (
                          formatCalculatedNumber(0.00, {prefix: "$"})
                        )}
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        colgroup={forecastColgroup}
                        showCurrencyConversion={showCurrencyConversion}
                        height="auto"
                        values={{
                          convertedTotal: (
                            convertedOrZero(calculated, {
                              amount: Object.keys(calculated).length > 0 ?
                                calculated.ticketsSection.externalForecastTotal + calculated.revenueSection.externalForecastTotal : 0
                            })
                          ),
                          total: (
                            Object.keys(calculated).length > 0 ? (
                              formatCalculatedNumber(
                                calculated.ticketsSection.externalForecastTotal + calculated.revenueSection.externalForecastTotal,
                                {prefix: "$"}
                              )
                            ) : (
                              formatCalculatedNumber(0, {prefix: "$"})
                            )
                          )
                        }}
                      />
                    </tr>
                    {Object.keys(calculated).length > 0 && calculated.beforeAdjustedDeductionsSection.total > 0 ? (
                      <>
                        <tr>
                          <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                            Before Adjusted Deductions
                          </td>
                          {showCurrencyConversion  ? (
                            <td className="pl-0 pt-0 pb-0 border-0 text-right">
                              {Object.keys(calculated).length > 0 ? (
                                `(${convertedOrZero(calculated, {dotPath: "beforeAdjustedDeductionsSection.total"})})`
                              ) : (
                                `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                              )}
                            </td>
                          ) : null}
                          <td className="pl-0 pt-0 pb-0 border-0 text-right">
                            {Object.keys(calculated).length > 0 ? (
                              `(${formatCalculatedNumber(calculated.beforeAdjustedDeductionsSection.total, {prefix: "$"})})`
                            ) : (
                              `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                            )}
                          </td>
                          <ForecastColumn
                            show={offer.display_forecast}
                            colgroup={forecastColgroup}
                            showCurrencyConversion={showCurrencyConversion}
                            height="auto"
                            values={{
                              convertedTotal: (
                                Object.keys(calculated).length > 0 ? (
                                  `(${convertedOrZero(calculated, {dotPath: "beforeAdjustedDeductionsSection.externalForecastTotal"})})`
                                ) : (
                                  `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                                )
                              ),
                              total: (
                                Object.keys(calculated).length > 0 ? (
                                  `(${formatCalculatedNumber(calculated.beforeAdjustedDeductionsSection.externalForecastTotal, {prefix: "$"})})`
                                ) : (
                                  `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                                )
                              )
                            }}
                          />
                        </tr>
                        <tr>
                          <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                            Adjusted Gross Potential
                          </td>
                          {showCurrencyConversion  ? (
                            <td className="pl-0 pt-0 pb-0 border-0 text-right">
                              {Object.keys(calculated).length > 0 ? (
                                convertedOrZero(calculated, {dotPath: "showSummary.netBoxOfficeReceipts"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </td>
                          ) : null}
                          <td className="pl-0 pt-0 pb-0 border-0 text-right">
                            {Object.keys(calculated).length > 0 ? (
                              formatCalculatedNumber(calculated.showSummary.netBoxOfficeReceipts, {prefix: "$"})
                            ) : (
                              formatCalculatedNumber(0.00, {prefix: "$"})
                            )}
                          </td>
                          <ForecastColumn
                            show={offer.display_forecast}
                            colgroup={forecastColgroup}
                            showCurrencyConversion={showCurrencyConversion}
                            height="auto"
                            values={{
                              convertedTotal: (
                                Object.keys(calculated).length > 0 ? (
                                  convertedOrZero(calculated, {dotPath: "showSummary.netBoxOfficeReceiptsForecast"})
                                ) : (
                                  formatCalculatedNumber(0.00, {prefix: "$"})
                                )
                              ),
                              total: (
                                Object.keys(calculated).length > 0 ? (
                                  formatCalculatedNumber(calculated.showSummary.netBoxOfficeReceiptsForecast, {prefix: "$"})
                                ) : (
                                  formatCalculatedNumber(0.00, {prefix: "$"})
                                )
                              )
                            }}
                          />
                        </tr>
                      </>
                    ) : null}
                    <tr>
                      <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                        Expenses
                      </td>
                      {showCurrencyConversion  ? (
                        <td className="pl-0 pt-0 pb-0 border-0 text-right">
                          {Object.keys(calculated).length > 0 ? (
                            `(${convertedOrZero(calculated, {dotPath: "expensesSection.total"})})`
                          ) : (
                            `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                          )}
                        </td>
                      ) : null}
                      <td className="pl-0 pt-0 pb-0 border-0 text-right">
                        {Object.keys(calculated).length > 0 ? (
                          `(${formatCalculatedNumber(calculated.expensesSection.total, {prefix: "$"})})`
                        ) : (
                          `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                        )}
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        colgroup={forecastColgroup}
                        showCurrencyConversion={showCurrencyConversion}
                        height="auto"
                        values={{
                          convertedTotal: (
                            Object.keys(calculated).length > 0 ? (
                              `(${convertedOrZero(calculated, {dotPath: "expensesSection.externalForecastTotal"})})`
                            ) : (
                              `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                            )
                          ),
                          total: (
                            Object.keys(calculated).length > 0 ? (
                              `(${formatCalculatedNumber(calculated.expensesSection.externalForecastTotal, {prefix: "$"})})`
                            ) : (
                              `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                            )
                          )
                        }}
                      />
                    </tr>
                    <tr>
                      <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                        <strong>
                          Show Net, After Expenses
                        </strong>
                      </td>
                      {showCurrencyConversion  ? (
                        <td className="pl-0 pt-0 pb-0 border-0 text-right">
                          <strong>
                            {Object.keys(calculated).length > 0 ? (
                              convertedOrZero(calculated, {dotPath: "showSummary.showNetAfterExpenses"})
                            ) : (
                              formatCalculatedNumber(0.00, {prefix: "$"})
                            )}
                          </strong>
                        </td>
                      ) : null}
                      <td className="pl-0 pt-0 pb-0 border-0 text-right">
                        <strong>
                          {Object.keys(calculated).length > 0 ? (
                            formatCalculatedNumber(calculated.showSummary.showNetAfterExpenses, {prefix: "$"})
                          ) : (
                            formatCalculatedNumber(0.00, {prefix: "$"})
                          )}
                        </strong>
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        colgroup={forecastColgroup}
                        showCurrencyConversion={showCurrencyConversion}
                        height="auto"
                        values={{
                          convertedTotal: (
                            <strong>
                              {Object.keys(calculated).length > 0 ? (
                                convertedOrZero(calculated, {dotPath: "showSummary.showNetAfterExpensesForecast"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </strong>
                          ),
                          total: (
                            <strong>
                              {Object.keys(calculated).length > 0 ? (
                                formatCalculatedNumber(calculated.showSummary.showNetAfterExpensesForecast, {prefix: "$"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </strong>
                          )
                        }}
                      />
                    </tr>
                    {Object.keys(calculated).length > 0 && calculated.finalExpensesSection.total > 0 ? (
                      <>
                        <tr>
                          <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                            <span>Final Expenses</span>
                            <Tippy content={
                                     <div style={{
                                            "fontSize": "10px"
                                          }}>
                                       <p className="mb-0">Final Expenses include any expense that require the total expenses or show net to be calculated beforehand:</p>
                                       <ul className="mt-2 mb-2">
                                         <li className="pl-0">Percentage of Expenses calculations</li>
                                         <li className="pl-0">Percentage of Net calculations</li>
                                       </ul>
                                     </div>
                                   }
                                   placement={'top'}
                                   maxWidth={390}
                                   animation={'shift-away'}
                                   theme='material'>
                              <a href="#" className="text-muted ml-2">
                                <i className="fas fa-info-circle"></i>
                              </a>
                            </Tippy>
                          </td>
                          {showCurrencyConversion  ? (
                            <td className="pl-0 pt-0 pb-0 border-0 text-right">
                              {Object.keys(calculated).length > 0 ? (
                                `(${convertedOrZero(calculated, {dotPath: "finalExpensesSection.total"})})`
                              ) : (
                                `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                              )}
                            </td>
                          ) : null}
                          <td className="pl-0 pt-0 pb-0 border-0 text-right">
                            {Object.keys(calculated).length > 0 ? (
                              `(${formatCalculatedNumber(calculated.finalExpensesSection.total, {prefix: "$"})})`
                            ) : (
                              `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                            )}
                          </td>
                          <ForecastColumn
                            show={offer.display_forecast}
                            colgroup={forecastColgroup}
                            showCurrencyConversion={showCurrencyConversion}
                            height="auto"
                            values={{
                              convertedTotal: (
                                Object.keys(calculated).length > 0 ? (
                                  `(${convertedOrZero(calculated, {dotPath: "finalExpensesSection.externalForecastTotal"})})`
                                ) : (
                                  `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                                )
                              ),
                              total: (
                                Object.keys(calculated).length > 0 ? (
                                  `(${formatCalculatedNumber(calculated.finalExpensesSection.externalForecastTotal, {prefix: "$"})})`
                                ) : (
                                  `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                                )
                              )
                            }}
                          />
                        </tr>
                        <tr>
                          <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                            <strong>
                              Show Net, After Final Expenses
                            </strong>
                          </td>
                          {showCurrencyConversion  ? (
                            <td className="pl-0 pt-0 pb-0 border-0 text-right">
                              <strong>
                                {Object.keys(calculated).length > 0 ? (
                                  convertedOrZero(calculated, {dotPath: "showSummary.showNetAfterFinalExpenses"})
                                ) : (
                                  formatCalculatedNumber(0.00, {prefix: "$"})
                                )}
                              </strong>
                            </td>
                          ) : null}
                          <td className="pl-0 pt-0 pb-0 border-0 text-right">
                            <strong>
                              {Object.keys(calculated).length > 0 ? (
                                formatCalculatedNumber(calculated.showSummary.showNetAfterFinalExpenses, {prefix: "$"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </strong>
                          </td>
                          <ForecastColumn
                            show={offer.display_forecast}
                            colgroup={forecastColgroup}
                            showCurrencyConversion={showCurrencyConversion}
                            height="auto"
                            values={{
                              convertedTotal: (
                                <strong>
                                  {Object.keys(calculated).length > 0 ? (
                                    convertedOrZero(calculated, {dotPath: "showSummary.showNetAfterFinalExpensesForecast"})
                                  ) : (
                                    formatCalculatedNumber(0.00, {prefix: "$"})
                                  )}
                                </strong>
                              ),
                              total: (
                                <strong>
                                  {Object.keys(calculated).length > 0 ? (
                                    formatCalculatedNumber(calculated.showSummary.showNetAfterFinalExpensesForecast, {prefix: "$"})
                                  ) : (
                                    formatCalculatedNumber(0.00, {prefix: "$"})
                                  )}
                                </strong>
                              )
                            }}
                          />
                        </tr>
                      </>
                    ) : null}
                    {Object.keys(calculated).length > 0 && calculated.showSummary.promoterProfit > 0 ? (
                      <>
                        <tr>
                          <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                            <span>Promoter Profit</span>
                          </td>
                          {showCurrencyConversion  ? (
                            <td className="pl-0 pt-0 pb-0 border-0 text-right">
                              {Object.keys(calculated).length > 0 ? (
                                `(${convertedOrZero(calculated, {dotPath: "showSummary.promoterProfit"})})`
                              ) : (
                                `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                              )}
                            </td>
                          ) : null}
                          <td className="pl-0 pt-0 pb-0 border-0 text-right">
                            {Object.keys(calculated).length > 0 ? (
                              `(${formatCalculatedNumber(calculated.showSummary.promoterProfit, {prefix: "$"})})`
                            ) : (
                              `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                            )}
                          </td>
                          <ForecastColumn
                            show={offer.display_forecast}
                            colgroup={forecastColgroup}
                            showCurrencyConversion={showCurrencyConversion}
                            height="auto"
                            values={{
                              convertedTotal: (
                                Object.keys(calculated).length > 0 ? (
                                  `(${convertedOrZero(calculated, {dotPath: "showSummary.promoterProfitForecast"})})`
                                ) : (
                                  `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                                )
                              ),
                              total: (
                                Object.keys(calculated).length > 0 ? (
                                  `(${formatCalculatedNumber(calculated.showSummary.promoterProfitForecast, {prefix: "$"})})`
                                ) : (
                                  `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                                )
                              )
                            }}
                          />
                        </tr>
                        <tr>
                          <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                            <strong>
                              Show Net, After Promoter Profit
                            </strong>
                          </td>
                          {showCurrencyConversion  ? (
                            <td className="pl-0 pt-0 pb-0 border-0 text-right">
                              <strong>
                                {Object.keys(calculated).length > 0 ? (
                                  convertedOrZero(calculated, {dotPath: "showSummary.showNetAfterPromoterProfit"})
                                ) : (
                                  formatCalculatedNumber(0.00, {prefix: "$"})
                                )}
                              </strong>
                            </td>
                          ) : null}
                          <td className="pl-0 pt-0 pb-0 border-0 text-right">
                            <strong>
                              {Object.keys(calculated).length > 0 ? (
                                formatCalculatedNumber(calculated.showSummary.showNetAfterPromoterProfit, {prefix: "$"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </strong>
                          </td>
                          <ForecastColumn
                            show={offer.display_forecast}
                            colgroup={forecastColgroup}
                            showCurrencyConversion={showCurrencyConversion}
                            height="auto"
                            values={{
                              convertedTotal: (
                                <strong>
                                  {Object.keys(calculated).length > 0 ? (
                                    convertedOrZero(calculated, {dotPath: "showSummary.showNetAfterPromoterProfitForecast"})
                                  ) : (
                                    formatCalculatedNumber(0.00, {prefix: "$"})
                                  )}
                                </strong>
                              ),
                              total: (
                                <strong>
                                  {Object.keys(calculated).length > 0 ? (
                                    formatCalculatedNumber(calculated.showSummary.showNetAfterPromoterProfitForecast, {prefix: "$"})
                                  ) : (
                                    formatCalculatedNumber(0.00, {prefix: "$"})
                                  )}
                                </strong>
                              )
                            }}
                          />
                        </tr>
                      </>
                    ) : null}
                    <tr>
                      <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                        Split Point
                      </td>
                      {showCurrencyConversion  ? (
                        <td className="pl-0 pt-0 pb-0 border-0 text-right">
                          {Object.keys(calculated).length > 0 ? (
                            convertedOrZero(calculated, {dotPath: "showSummary.splitPoint"})
                          ) : (
                            formatCalculatedNumber(0.00, {prefix: "$"})
                          )}
                        </td>
                      ) : null}
                      <td className="pl-0 pt-0 pb-0 border-0 text-right">
                        {Object.keys(calculated).length > 0 ? (
                          formatCalculatedNumber(calculated.showSummary.splitPoint, {prefix: "$"})
                        ) : (
                          formatCalculatedNumber(0.00, {prefix: "$"})
                        )}
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        colgroup={forecastColgroup}
                        showCurrencyConversion={showCurrencyConversion}
                        height="auto"
                        values={{
                          convertedTotal: (
                            Object.keys(calculated).length > 0 ? (
                              convertedOrZero(calculated, {dotPath: "showSummary.splitPointForecast"})
                            ) : (
                              formatCalculatedNumber(0.00, {prefix: "$"})
                            )
                          ),
                          total: (
                            Object.keys(calculated).length > 0 ? (
                              formatCalculatedNumber(calculated.showSummary.splitPointForecast, {prefix: "$"})
                            ) : (
                              formatCalculatedNumber(0.00, {prefix: "$"})
                            )
                          )
                        }}
                      />
                    </tr>
                    <tr>
                      <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                        Artist Amount from Split
                      </td>
                      {showCurrencyConversion  ? (
                        <td className="pl-0 pt-0 pb-0 border-0 text-right">
                          {Object.keys(calculated).length > 0 ? (
                            convertedOrZero(calculated, {dotPath: "showSummary.artistPercentage"})
                          ) : (
                            formatCalculatedNumber(0.00, {prefix: "$"})
                          )}
                        </td>
                      ) : null}
                      <td className="pl-0 pt-0 pb-0 border-0 text-right">
                        {Object.keys(calculated).length > 0 ? (
                          formatCalculatedNumber(calculated.showSummary.artistPercentage, {prefix: "$"})
                        ) : (
                          formatCalculatedNumber(0.00, {prefix: "$"})
                        )}
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        colgroup={forecastColgroup}
                        showCurrencyConversion={showCurrencyConversion}
                        height="auto"
                        values={{
                          convertedTotal: (
                            Object.keys(calculated).length > 0 ? (
                              convertedOrZero(calculated, {dotPath: "showSummary.artistPercentageForecast"})
                            ) : (
                              formatCalculatedNumber(0.00, {prefix: "$"})
                            )
                          ),
                          total: (
                            Object.keys(calculated).length > 0 ? (
                              formatCalculatedNumber(calculated.showSummary.artistPercentageForecast, {prefix: "$"})
                            ) : (
                              formatCalculatedNumber(0.00, {prefix: "$"})
                            )
                          )
                        }}
                      />
                    </tr>
                    {shortfall ? (
                      <tr>
                        <td colSpan={showCurrencyConversion ? 8 : 7} className="pl-0 pt-2 pb-2 border-0">
                          <div className="d-flex justify-content-end">
                            <div style={{ maxWidth: '420px' }}>
                              <SplitShortfallCallout shortfall={shortfall} />
                            </div>
                          </div>
                        </td>
                        <ForecastColumn
                          show={offer.display_forecast}
                          colgroup={forecastColgroup}
                          showCurrencyConversion={showCurrencyConversion}
                          height="1px"
                          values={{ convertedTotal: null, total: null }}
                        />
                      </tr>
                    ) : null}
                    {Object.keys(calculated).length > 0 && calculated.additionsSection.total > 0 ? (
                      <tr>
                        <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                          Total Additions
                        </td>
                        {showCurrencyConversion  ? (
                          <td className="pl-0 pt-0 pb-0 border-0 text-right">
                            {Object.keys(calculated).length > 0 ? (
                              convertedOrZero(calculated, {dotPath: "additionsSection.total"})
                            ) : (
                              formatCalculatedNumber(0.00, {prefix: "$"})
                            )}
                          </td>
                        ) : null}
                        <td className="pl-0 pt-0 pb-0 border-0 text-right">
                          {Object.keys(calculated).length > 0 ? (
                            formatCalculatedNumber(calculated.additionsSection.total, {prefix: "$"})
                          ) : (
                            formatCalculatedNumber(0.00, {prefix: "$"})
                          )}
                        </td>
                        <ForecastColumn
                          show={offer.display_forecast}
                          colgroup={forecastColgroup}
                          showCurrencyConversion={showCurrencyConversion}
                          height="auto"
                          values={{
                            convertedTotal: (
                              Object.keys(calculated).length > 0 ? (
                                convertedOrZero(calculated, {dotPath: "additionsSection.externalForecastTotal"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )
                            ),
                            total: (
                              Object.keys(calculated).length > 0 ? (
                                formatCalculatedNumber(calculated.additionsSection.externalForecastTotal, {prefix: "$"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )
                            )
                          }}
                        />
                      </tr>
                    ) : null}
                    {budget.has_tax_withholding ? (
                      <tr>
                        <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                          Tax Withholding
                        </td>
                        {showCurrencyConversion  ? (
                          <td className="pl-0 pt-0 pb-0 border-0 text-right">
                            {Object.keys(calculated).length > 0 ? (
                              convertedOrZero(calculated, {dotPath: "artistEarnings.taxWithholding"})
                            ) : (
                              formatCalculatedNumber(0.00, {prefix: "$"})
                            )}
                          </td>
                        ) : null}
                        <td className="pl-0 pt-0 pb-0 border-0 text-right">
                          {Object.keys(calculated).length > 0 ? (
                            `(${formatCalculatedNumber(calculated.artistEarnings.taxWithholding, {prefix: "$"})})`
                          ) : (
                            `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                          )}
                        </td>
                        <ForecastColumn
                          show={offer.display_forecast}
                          colgroup={forecastColgroup}
                          showCurrencyConversion={showCurrencyConversion}
                          height="auto"
                          values={{
                            convertedTotal: (
                              Object.keys(calculated).length > 0 ? (
                                convertedOrZero(calculated, {dotPath: "artistEarningsForecast.taxWithholding"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )
                            ),
                            total: (
                              Object.keys(calculated).length > 0 ? (
                                `(${formatCalculatedNumber(calculated.taxWithholdingForecast, {prefix: "$"})})`
                              ) : (
                                `(${formatCalculatedNumber(0.00, {prefix: "$"})})`
                              )
                            )
                          }}
                        />
                      </tr>
                    ) : null}
                    <tr>
                      <td
                        colSpan={showCurrencyConversion ? 8 : 7}
                        className="p-0"
                      >
                        &nbsp;
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        showCurrencyConversion={showCurrencyConversion}
                      />
                    </tr>
                    <tr style={{fontSize: "16px"}}>
                      <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                        <strong>
                          Potential Artist Earnings
                        </strong>
                      </td>
                      {showCurrencyConversion  ? (
                        <td className="pl-0 pt-0 pb-0 border-0 text-right">
                          <strong>
                            {Object.keys(calculated).length > 0 ? (
                              convertedOrZero(calculated, {dotPath: "artistEarnings.artistSettlementDue"})
                            ) : (
                              formatCalculatedNumber(0.00, {prefix: "$"})
                            )}
                          </strong>
                        </td>
                      ) : null}
                      <td className="pl-0 pt-0 pb-0 border-0 text-right">
                        <strong>
                          {Object.keys(calculated).length > 0 ? (
                            formatCalculatedNumber(calculated.artistEarnings.artistSettlementDue, {prefix: "$"})
                          ) : (
                            formatCalculatedNumber(0.00, {prefix: "$"})
                          )}
                        </strong>
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        colgroup={forecastColgroup}
                        showCurrencyConversion={showCurrencyConversion}
                        height="auto"
                        values={{
                          convertedTotal: (
                            <strong style={{fontSize: "16px"}}>
                              {Object.keys(calculated).length > 0 ? (
                                convertedOrZero(calculated, {dotPath: "artistEarningsForecast.artistSettlementDue"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </strong>
                          ),
                          total: (
                            <strong style={{fontSize: "16px"}}>
                              {Object.keys(calculated).length > 0 ? (
                                formatCalculatedNumber(calculated.artistEarningsForecast.artistSettlementDue, {prefix: "$"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </strong>
                          )
                        }}
                      />
                    </tr>
                    <tr style={{fontSize: "16px"}}>
                      <td colSpan="6" className="pl-0 pt-0 pb-0 border-0 text-right">
                        <strong>
                          Venue Net Potential
                        </strong>
                      </td>
                      {showCurrencyConversion  ? (
                        <td className="pl-0 pt-0 pb-0 border-0 text-right">
                          <strong>
                            {Object.keys(calculated).length > 0 ? (
                              convertedOrZero(calculated, {dotPath: "showSummary.venueNetPotential"})
                            ) : (
                              formatCalculatedNumber(0.00, {prefix: "$"})
                            )}
                          </strong>
                        </td>
                      ) : null}
                      <td className="pl-0 pt-0 pb-0 border-0 text-right">
                        <strong>
                          {Object.keys(calculated).length > 0 ? (
                            formatCalculatedNumber(calculated.showSummary.venueNetPotential, {prefix: "$"})
                          ) : (
                            formatCalculatedNumber(0.00, {prefix: "$"})
                          )}
                        </strong>
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        colgroup={forecastColgroup}
                        showCurrencyConversion={showCurrencyConversion}
                        height="auto"
                        values={{
                          convertedTotal: (
                            <strong style={{fontSize: "16px"}}>
                              {Object.keys(calculated).length > 0 ? (
                                convertedOrZero(calculated, {dotPath: "showSummary.venueNetPotentialForecast"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </strong>
                          ),
                          total: (
                            <strong style={{fontSize: "16px"}}>
                              {Object.keys(calculated).length > 0 ? (
                                formatCalculatedNumber(calculated.showSummary.venueNetPotentialForecast, {prefix: "$"})
                              ) : (
                                formatCalculatedNumber(0.00, {prefix: "$"})
                              )}
                            </strong>
                          )
                        }}
                      />
                    </tr>
                    <tr>
                      <td
                        colSpan={showCurrencyConversion ? 8 : 7}
                        className="p-0">
                        &nbsp;
                      </td>
                      <ForecastColumn
                        show={offer.display_forecast}
                        bottom={true}
                        showCurrencyConversion={showCurrencyConversion}
                      />
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="row" style={{"marginTop": budget.has_tax_withholding ? "0px" : "21px"}}>
                <div className="col-12 col-xl-6" style={{"marginBottom": "16px"}}>
                  <div className="custom-control custom-switch">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="budget-tax-withholding-switch"
                      checked={budget.has_tax_withholding || false}
                      onChange={e => {
                        var updated = Object.assign({}, budget, {
                          has_tax_withholding: e.target.checked
                        });

                        updateBudget(updated);
                        autoSaveBudget(csrfToken, team, updated)
                      }}
                    />
                    <label className="custom-control-label" htmlFor="budget-tax-withholding-switch">
                      <h3 style={{"fontSize": "20px"}}>
                        <strong>
                          Tax Withholding
                        </strong>
                      </h3>
                    </label>
                  </div>
                  <div className='form-row'>
                    <div className="col-6 col-xl-4 text-truncate">
                      <div className="form-group" style={{"marginBottom": "2px"}}>
                        <label className="text-muted"
                              style={{"marginBottom": "3px"}}
                              htmlFor="budget-tax-withholding-threshold">
                          Minimum Threshold
                        </label>
                        <div className="input-group inline-white"
                            style={{
                              "border": "1px solid var(--od-c-e9eaeb, #ececec)",
                              "borderRadius": "4px"
                            }}>
                          <div className="input-group-prepend">
                            <span className="input-group-text px-2">
                              <i className="far fa-dollar-sign text-muted"></i>
                            </span>
                          </div>
                          <CurrencyInput
                            id="budget-tax-withholding-threshold"
                            className="form-control"
                            maskOptions={{ prefix: "", integerLimit: null }}
                            placeholder={"0"}
                            value={budget.tax_withholding_minimum_threshold}
                            onFocus={e => e.target.select()}
                            onChange={e => {
                              var updated = Object.assign({}, budget, {
                                tax_withholding_minimum_threshold: e.target.value
                              });

                              updateBudget(updated);
                              debouncedAutoSaveBudget(csrfToken, team, updated);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-xl-4 text-truncate">
                      <div className="form-group" style={{"marginBottom": "2px"}}>
                        <label className="text-muted"
                              style={{"marginBottom": "3px"}}
                              htmlFor="budget-tax-withholding-percentage">
                          Withholding
                        </label>
                        <div className="input-group inline-white"
                            style={{
                              "border": "1px solid var(--od-c-e9eaeb, #ececec)",
                              "borderRadius": "4px"
                            }}>
                          <CurrencyInput
                            id="budget-tax-withholding-percentage"
                            className="form-control"
                            maskOptions={{ prefix: "", integerLimit: null }}
                            placeholder={"0"}
                            value={budget.tax_withholding_percentage}
                            onFocus={e => e.target.select()}
                            onChange={e => {
                              var updated = Object.assign({}, budget, {
                                tax_withholding_percentage: e.target.value
                              });

                              updateBudget(updated);
                              debouncedAutoSaveBudget(csrfToken, team, updated);
                            }}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text px-2">
                              <i className="far fa-percentage text-muted"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-xl-4 text-truncate">
                      <div className="form-group" style={{"marginBottom": "2px"}}>
                        <label className="text-muted"
                              style={{"marginBottom": "3px"}}
                              htmlFor="budget-tax-withholding-due-days">
                          Due date
                        </label>
                        <div className="input-group inline-white"
                            style={{
                              "border": "1px solid var(--od-c-e9eaeb, #ececec)",
                              "borderRadius": "4px"
                            }}>
                          <CurrencyInput
                            id="budget-tax-withholding-due-days"
                            className="form-control"
                            maskOptions={{ prefix: "", integerLimit: null, allowDecimal: false }}
                            placeholder={"0"}
                            value={budget.tax_withholding_due_days || 0}
                            onFocus={e => e.target.select()}
                            onChange={e => {
                              var updated = Object.assign({}, budget, {
                                tax_withholding_due_days: e.target.value
                              });

                              updateBudget(updated);
                              debouncedAutoSaveBudget(csrfToken, team, updated);
                            }}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text px-2" style={{"fontSize": "12px"}}>
                              Days after event
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr className="mb-4"
                  style={{"borderTop": "2px solid var(--od-c-e9eaeb, #e6e6e6)"}} />
              <div className="row">
                <div className="col-12 col-xl-6" style={{"marginBottom": "16px"}}>
                  <div className="form-group mb-0">
                    <h3 style={{"fontSize": "20px"}}>
                      <strong>
                        Merchandising
                      </strong>
                    </h3>
                  </div>
                  <div className='form-row'>
                    <div className="col-6 col-xl-3 text-truncate">
                      <div className="form-group" style={{"marginBottom": "2px"}}>
                        <label className="text-muted"
                              style={{"marginBottom": "3px"}}
                              htmlFor="offer-soft-merch-rate">
                          Soft Merch Rate (artist %)
                        </label>
                        <div className="input-group inline-white"
                            style={{
                              "border": "1px solid var(--od-c-e9eaeb, #ececec)",
                              "borderRadius": "4px"
                            }}>
                          <CurrencyInput className="form-control form-control-sm"
                                   maskOptions={{
                                     prefix: "",
                                     integerLimit: null
                                   }}
                                   placeholder={"0"}
                                   value={budget.soft_merch_rate || ""}
                                   onChange={
                                     (e) => {
                                       var updated = Object.assign({}, budget, {
                                          soft_merch_rate: e.target.value
                                       });

                                       updateBudget(updated);
                                       debouncedAutoSaveBudget(csrfToken, team, updated);
                                     }
                                   }
                                   id="offer-soft-merch-rate" />
                          <div className="input-group-append">
                            <span className="input-group-text px-2"
                                  id="offer-upside-percentage-percentage">
                              <i className="far fa-percentage text-muted"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-xl-3">
                      <div className="form-group" style={{"marginBottom": "2px"}}>
                        <label className="text-muted"
                              style={{"marginBottom": "3px"}}
                              htmlFor="offer-soft-merch-sold-by">
                          Sold by
                        </label>
                        <select className="form-control form-control-sm"
                                style={{"border": "1px solid var(--od-c-e9eaeb, #ececec)"}}
                                value={budget.soft_merch_sold_by || ""}
                                onChange={
                                  (e) => {
                                    var updated = Object.assign({}, budget, {
                                      soft_merch_sold_by: e.target.value
                                    });

                                    updateBudget(updated);
                                    debouncedAutoSaveBudget(csrfToken, team, updated);
                                  }
                                }
                                id="offer-soft-merch-sold-by">
                          <option value="">--</option>
                          <option value="Artist">Artist</option>
                          <option value="Venue">Venue</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12 col-xl-6">
                      <div className="form-group" style={{"marginBottom": "2px"}}>
                        <label className="text-muted"
                              style={{"marginBottom": "3px"}}
                              htmlFor="offer-soft-merch-notes">
                          Soft Merch Notes
                        </label>
                        <DebounceInput className="form-control form-control-sm"
                                type="text"
                                style={{"border": "1px solid var(--od-c-e9eaeb, #ececec)"}}
                                value={budget.soft_merch_notes || ""}
                                onChange={
                                  (e) => {
                                    var updated = Object.assign({}, budget, {
                                      soft_merch_notes: e.target.value
                                    });

                                    updateBudget(updated);
                                    debouncedAutoSaveBudget(csrfToken, team, updated);
                                  }
                                }
                                id="offer-soft-merch-notes" />
                      </div>
                    </div>
                  </div>
                  <div className='form-row'>
                    <div className="col-6 col-xl-3 text-truncate">
                      <div className="form-group" style={{"marginBottom": "2px"}}>
                        <label className="text-muted"
                              style={{"marginBottom": "3px"}}
                              htmlFor="offer-hard-merch-rate">
                          Hard Merch Rate (artist %)
                        </label>
                        <div className="input-group inline-white"
                            style={{
                              "border": "1px solid var(--od-c-e9eaeb, #ececec)",
                              "borderRadius": "4px"
                            }}>
                          <CurrencyInput className="form-control form-control-sm"
                                   maskOptions={{
                                     prefix: "",
                                     integerLimit: null
                                   }}
                                   placeholder={"0"}
                                   value={budget.hard_merch_rate || ""}
                                   onChange={
                                     (e) => {
                                       var updated = Object.assign({}, budget, {
                                          hard_merch_rate: e.target.value
                                       });

                                       updateBudget(updated);
                                       debouncedAutoSaveBudget(csrfToken, team, updated);
                                     }
                                   }
                                   id="offer-hard-merch-rate" />
                          <div className="input-group-append">
                            <span className="input-group-text px-2"
                                  id="offer-upside-percentage-percentage">
                              <i className="far fa-percentage text-muted"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-xl-3">
                      <div className="form-group" style={{"marginBottom": "2px"}}>
                        <label className="text-muted"
                              style={{"marginBottom": "3px"}}
                              htmlFor="offer-hard-merch-sold-by">
                          Sold by
                        </label>
                        <select className="form-control form-control-sm"
                                style={{"border": "1px solid var(--od-c-e9eaeb, #ececec)"}}
                                value={budget.hard_merch_sold_by || ""}
                                onChange={
                                  (e) => {
                                    var updated = Object.assign({}, budget, {
                                      hard_merch_sold_by: e.target.value
                                    });

                                    updateBudget(updated);
                                    debouncedAutoSaveBudget(csrfToken, team, updated);
                                  }
                                }
                                id="offer-hard-merch-sold-by">
                          <option value="">--</option>
                          <option value="Artist">Artist</option>
                          <option value="Venue">Venue</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12 col-xl-6">
                      <div className="form-group" style={{"marginBottom": "2px"}}>
                        <label className="text-muted"
                              style={{"marginBottom": "3px"}}
                              htmlFor="offer-hard-merch-notes">
                          Hard Merch Notes
                        </label>
                        <DebounceInput className="form-control form-control-sm"
                                type="text"
                                style={{"border": "1px solid var(--od-c-e9eaeb, #ececec)"}}
                                value={budget.hard_merch_notes || ""}
                                onChange={
                                  (e) => {
                                    var updated = Object.assign({}, budget, {
                                      hard_merch_notes: e.target.value
                                    });

                                    updateBudget(updated);
                                    debouncedAutoSaveBudget(csrfToken, team, updated);
                                  }
                                }
                                id="offer-hard-merch-notes" />
                      </div>
                    </div>
                  </div>
                  <div className='form-row'>
                    <div className="col-12">
                      <div className="form-group" style={{"marginBottom": "2px"}}>
                        <label className="text-muted"
                              style={{"marginBottom": "3px"}}
                              htmlFor="offer-addl-merch-notes">
                          Additional Merch Notes
                        </label>
                        <DebounceInput className="form-control form-control-sm"
                                type="text"
                                style={{"border": "1px solid var(--od-c-e9eaeb, #ececec)"}}
                                value={budget.addl_merch_notes || ""}
                                onChange={
                                  (e) => {
                                    var updated = Object.assign({}, budget, {
                                      addl_merch_notes: e.target.value
                                    });

                                    updateBudget(updated);
                                    debouncedAutoSaveBudget(csrfToken, team, updated);
                                  }
                                }
                                id="offer-addl-merch-notes" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr className="mb-4"
                  style={{"borderTop": "2px solid var(--od-c-e9eaeb, #e6e6e6)"}} />
              <h3 style={{"fontSize": "20px"}}>
                <strong>Deposits</strong>
              </h3>
              <div className="row">
                <div className="col-12 pt-2">
                  <DepositManager
                    csrfToken={csrfToken}
                    team={team}
                    budget={budget}
                    updateBudget={updateBudget}
                    currentUser={currentUser}
                    debouncedAutoSaveBudget={debouncedAutoSaveBudget}
                  />
                </div>
              </div>
              <hr className="mb-4"
                  style={{"borderTop": "2px solid var(--od-c-e9eaeb, #e6e6e6)"}} />
              <h3 style={{"fontSize": "20px"}}>
                <strong>Contacts</strong>
              </h3>
              <div className="row">
                <div className="col-12 pt-2">
                  <OfferManageContacts
                    csrfToken={csrfToken}
                    team={team}
                    offer={offer}
                    offerContacts={offerContacts}
                    offerContactsChanged={offerContactsChanged}
                    currentUser={currentUser}
                  />
                </div>
              </div>
              <hr className="mb-4"
                  style={{"borderTop": "2px solid var(--od-c-e9eaeb, #e6e6e6)"}} />
              <h3 style={{"fontSize": "20px"}}>
                <strong>Additional Terms</strong>
              </h3>
              <div className="row">
                <div className="col-12 pt-2">
                  <RichEditor
                    editorState={additionalOfferTerms}
                    onEditorStateChange={
                      (editorState) => {
                        setAdditionalOfferTerms(current => {
                          const currentText = richTextToHtml(editorState.getCurrentContent());
                          const newText = richTextToHtml(current.getCurrentContent());

                          if (currentText !== newText) {
                            var updated = Object.assign({}, offer, {additionalTerms: editorState});

                            updateOffer(updated);
                            debouncedAutoSaveOffer(csrfToken, team, updated, editorState);
                          }

                          return editorState;
                        });
                      }
                    } />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup
        open={(modalUIState.length > 0)}
        contentStyle={modalContentStyle}
        closeOnDocumentClick={false}
        className={"offer-modal"}
        onClose={() => updateModalUIState("")}
      >
        <OfferV2PreviewApp offer={offer}
                           currentUser={currentUser}
                           csrfToken={csrfToken}
                           uiState={modalUIState}
                           onClose={
                             () => {
                               updateModalUIState("");
                             }
                           }
                           onSuccess={
                             (offer) => {
                               updateModalUIState("");
                               updateOffer(offer);

                               toast.success("Offer has been sent.", {
                                 position: toast.POSITION.TOP_CENTER,
                                 draggable: false,
                                 closeOnClick: false,
                                 autoClose: 5000,
                                 hideProgressBar: true
                               });
                             }
                           }
                           team={team} />
      </Popup>
      <Popup
        open={Object.keys(offerToLink).length > 0}
        contentStyle={linkOfferModalContentStyle}
        closeOnDocumentClick={false}
        className={"offer-modal"}
        onClose={() => {
          offerToLinkChanged({});
        }}
      >
        <LinkOfferModalApp currentUser={currentUser}
                           csrfToken={csrfToken}
                           offer={offerToLink}
                           onClose={
                             () => {
                               offerToLinkChanged({});
                             }
                           }
                           onSuccess={
                             (data) => {
                               var updated = Object.assign({}, offer, data);

                               updateOffer(updated);
                               offerToLinkChanged({});

                               toast.success("Offer has been updated.", {
                                 position: toast.POSITION.TOP_CENTER,
                                 draggable: false,
                                 closeOnClick: false,
                                 autoClose: 5000,
                                 hideProgressBar: true
                               });
                             }
                           }
                           team={team} />
      </Popup>
    </div>
  )
};

OfferEditUI.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  offer: PropTypes.object.isRequired,
  offerChanged: PropTypes.func,
  updateOfferAdditionalTermsFromHTML: PropTypes.func.isRequired,
  autoSaveOffer: PropTypes.func.isRequired,
  budget: PropTypes.object.isRequired,
  createTicketBudgetLineItem: PropTypes.func.isRequired,
  createAdditionBudgetLineItem: PropTypes.func.isRequired,
  createIncomeBudgetLineItem: PropTypes.func.isRequired,
  createBeforeAdjustedDeductionsBudgetLineItem: PropTypes.func.isRequired,
  createExpensesBudgetLineItem: PropTypes.func.isRequired,
  deleteBudgetLineItem: PropTypes.func.isRequired,
  autoSaveBudgetLineItem: PropTypes.func.isRequired,
  updateOffer: PropTypes.func.isRequired,
  updateBudget: PropTypes.func.isRequired,
  autoSaveBudget: PropTypes.func.isRequired,
  acceptOffer: PropTypes.func.isRequired,
  declineOffer: PropTypes.func.isRequired,
  deleteOffer: PropTypes.func.isRequired,
  calculated: PropTypes.object,
  updateCalculated: PropTypes.func.isRequired,
  modalUIState: PropTypes.string,
  updateModalUIState: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  isCreatingTemplate: PropTypes.bool,
  isCreatingTemplateChanged: PropTypes.func.isRequired,
  submitBudgetTemplate: PropTypes.func.isRequired,
  budgetTemplates: PropTypes.array,
  useBudgetTemplateWithBudget: PropTypes.func.isRequired,
  budgetTemplate: PropTypes.object,
  budgetTemplateNameChanged: PropTypes.func.isRequired,
  budgetTemplateChanged: PropTypes.func.isRequired,
  offerToLink: PropTypes.object,
  offerToLinkChanged: PropTypes.func.isRequired,
  deleteBudgetTemplate: PropTypes.func.isRequired,
  createBudgetBonus: PropTypes.func.isRequired,
  deleteBudgetBonus: PropTypes.func.isRequired,
  autoSaveBudgetBonus: PropTypes.func.isRequired,
  getActiveTags: PropTypes.func.isRequired,
  getAvailableTags: PropTypes.func.isRequired,
  offerContacts: PropTypes.array.isRequired,
  offerContactsChanged: PropTypes.func.isRequired,
  dealBrackets: PropTypes.array,
  dealBracketsChanged: PropTypes.func.isRequired,
  dealBracketChanged: PropTypes.func.isRequired
};

export default OfferEditUI;
